/* eslint-disable eqeqeq */
import { Component, OnInit, OnDestroy, HostListener, ViewChild, ChangeDetectorRef, DoCheck, ChangeDetectionStrategy, AfterViewInit, AfterContentChecked, QueryList, ViewChildren, NgZone, ElementRef } from '@angular/core';
import { CompilationModel, DeliveryConditions, DocumentFooter,
  InvoiceUpload,
  OfferData,
  PaymentPlan, ShipmentLineItem, TransportRun, FirstDate, PackingConditions, PackingConditionItem, EPackingStatus, 
  SpoPayment, ErpDate,
  PaymentPlanInvoice,
  isErpDate,
  ErpDateClassType,
  ProjectRemark} from '../../../@models/erp/compilation';
import {
  IssuerData, CompilationTypeData,
  PaymentConditionsData, DeliveryConditionsData,
  TaxHintData, VatPercentData, DocConfig, DocumentStatusData, Currency,
  CompilationDataModel, TransportStatusData, SpoStatusData, InvoiceStatusData,
  InvoicePaymentData, OfferStatusData, ActionPointData, DateSelectionData, AvailabilityStatusData, PackingStatusData,
  FiscalYearData,
  CountryCodes,
  PaymentDates,
} from '../../../@models/erp/compilationData';
import { Subscription ,  Observable, firstValueFrom } from 'rxjs';
import { LineItemContainerComponent } from '../document/line-item-container/line-item-container.component';
import { ApiService } from '../../../@core/service/api.service';
import { NbToastrService, NbDialogService, NbPopoverComponent, NbPopoverDirective } from '@nebular/theme';
import { BusinessModel, ContactFieldModel, ContactModel, EBusinessType, EContactFieldType,
  EContactType, FileModel, UserModel } from '../../../@models';
import { ComponentCanDeactivate } from '../../../@core/service/pending-changes-guard.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AbstractItem, AbstractItemType } from '../abstractItem';
import { NrkDialogButton, NrkDialogType, CommonDialogComponent,
  SpoChoice, InheritPriceOption } from '../shared/common-dialog/common-dialog.component';
import { DocumentPrinterComponent } from '../document/document-printer/document-printer.component';
import { AssociatedPfspo, LineItemModel, LineItemPosition } from '../../../@models/erp/lineItem';
import { DownstreamLineItems } from './line-item-container/line-item-remaining/line-item-remaining.component';
import { ContactUtil, DocFormAddressSelectorComponent } from '../shared/doc-form-address-selector/doc-form-address-selector.component';
import { DownloadType } from '../../../@models/erp/baseProduct';
import { nrkHrDummyId } from '../shared/doc-form-filter-select/doc-form-filter-select.component'
import { DatePipe } from '@angular/common';
import { ReportsPrinterComponent } from '../reports/reports-printer/reports-printer.component';
import * as uniqid from 'uniqid';
import { BaseProductModel } from '../../../@models/erp/baseProduct';
import { diacriticless, safeStringify, getDocumentNumber, mongoId, waitForVariable, getTotalNet } from '../../../@core/common/global';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { Changelog, ChangelogEntry, ChangelogEntryType } from '../shared/changelog/changelog.component';
import { DocumentSubComponentsComponent } from './document-sub-components/document-sub-components.component';
import { ReportDatesComponent } from './report-dates/report-dates.component';
import { TreeService } from '../../../@core/service/tree.service';
import * as moment from 'moment';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { ProductWizardComponent } from '../product-wizard/product-wizard.component';
import { DocMetrics } from './line-item-container/line-item-metrics/line-item-metrics.component';
import { RoundPipe } from '../../../@theme/pipes';
import { EventService } from '../../../@core/service/eventService';
import { TabCoordinatorService } from '../../../@core/service/tab-coordinator.service';
import { EMessagingWindowMode } from '../../warehousing/messaging/messaging.component';
import { EProductType } from '../../../@models/erp/finishedProduct';
import { ProfitMarginComponent, ProfitMarginType } from './payment-plan/profit-margin/profit-margin.component';
import { NrkWindowComponent } from '../shared/nrk-window/nrk-window.component';

class Filter {
  doctype: number;
  issuer: number;
  nrkdoc: string;
  recipient: BusinessModel;
  customerdoc: string;
  draftsOnly: boolean;
  offerStatus: number[];
  obic: string;
  lot: string;
  tcNumber: string;
  poDateFrom: Date;
  poDateTo: Date;
  exwDateFrom: Date;
  exwDateTo: Date;
  etaDateFrom: Date;
  etaDateTo: Date;
  dueDateFrom: Date;
  dueDateTo: Date;
  codes: string[];
  // accountManager: ContactModel;
  search: { text: string, column: string };
  sort: { column: string, dir: number };

  constructor() {
    this.clear();
  }

  clear() {
    this.doctype = null;
    this.issuer = null;
    this.nrkdoc = '';
    this.recipient = null;
    this.customerdoc = '';
    this.draftsOnly = false;
    this.offerStatus = [1,2,3,4,5];
    this.obic = '';
    this.lot = ''
    this.tcNumber = '';
    this.poDateFrom = null;
    this.poDateTo = null;
    this.exwDateFrom = null;
    this.exwDateTo = null;
    this.etaDateFrom = null;
    this.etaDateTo = null;
    this.dueDateFrom = null;
    this.dueDateTo = null;  
    // this.accountManager = null;
    this.search = { text: null, column: '' };
    this.sort = { column: null, dir: -1 };
  }
}

@Component({
  selector: 'ngx-erp-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentComponent
  extends AbstractItem<CompilationModel>
  implements OnInit, OnDestroy, AfterViewInit, ComponentCanDeactivate, DoCheck {

  items: CompilationModel[] = []; // all items, all versions
  // latestVersionItems: CompilationModel[];
  displayedItems: CompilationModel[];

  // compilationData: CompilationDataModel;
  issuer: number;

  // users: UserModel[];
  contacts: ContactModel[];
  // businesses: BusinessModel[];
  // finishedProductNames: NameTable[];
  baseProducts: BaseProductModel[];

  recipientBusinesses: BusinessModel[];
  deliveryBusinesses: BusinessModel[];
  manufacturerBusinesses: BusinessModel[];
  importerBusinesses: BusinessModel[];
  placeOfLoadingBusinesses: BusinessModel[];
  customerReferenceOptions: { id: string, name: string }[];

  owner: UserModel;
  selected: CompilationModel = new CompilationModel();

  contactTypes = EContactType;
  // userOptions: { id: string, name: string }[];
  // codeOptions: { id: string, name: string }[];
  recipientContactOptions: { id: string, name: string }[] = [];
  customerNumberOptions: { id: string, name: string }[];
  // employeeOptions: { id: string, name: string } [] = [];
  // businessOptions: { id: string, name: string }[];
  compilationTypeOptions = CompilationTypeData.getOptions();
  issuerOptions = IssuerData.getOptions();
  // meansOfTransportOptions: { id: string, name: string }[];
  termsOfPaymentOptions: { id: string, name: string }[];
  paymentConditionOptions = PaymentConditionsData.getOptions();
  deliveryConditionOptions = DeliveryConditionsData.getOptions();
  taxHintOptions = TaxHintData.getOptions();
  vatPercentOptions = VatPercentData.getOptions();
  currencyOptions = Currency.getOptions();
  invoiceStatusOptions = InvoiceStatusData.getOptions();
  actionPointOptions = ActionPointData.getOptions();
  offerStatusOptions = OfferStatusData.getOptions();
  invoicePaymentOptions = InvoicePaymentData.getOptions();
  paymentDates = PaymentDates.getOptions();
  
  visibleSections = [];

  docConfig = DocConfig;
  typeData = CompilationTypeData;
  issuerData = IssuerData;
  json = JSON;
  dateSelectionData = DateSelectionData;
  dnStatusText = PackingStatusData.text;
  messagingWindowMode = EMessagingWindowMode;
  profitMarginType = ProfitMarginType;

  fiscalYearOptions = FiscalYearData.getOptions();

  checkVisibleMap: any = {}
  checkReadOnlyMap: any = {}

  offerFields = DocConfig.getArray()
    .filter(f => f.value['offerField'] === true);
  percentOptions = [0,10,20,30,40,50,60,70,80,90,100].map(m => ({id: m, name: m+'%'}))
  statusCommentOptions = OfferStatusData.getOptions(1);

  downstreamDocuments: CompilationModel[];
  relatedDocuments: { doc: CompilationModel, text: string }[];
  nrkaOrder: string[] = []; // Associated NRKA Order if current document is a NRKG PFSPC
  nrkgOc: string[] = []; // Associated NRKG Order confirmation if current document is a NRKA OC

  filter: Filter = new Filter();

  templatesOnly = false;

  priceDate: Date;

  showDocumentPreview = false;
  showDocumentPreviewHidden = false;

  showWizard = false;

  subscriptions: Subscription[] = [];

  reviseText = null;

  contactUtil: ContactUtil;

  invoiceSendTo = '';
  invoiceSendToInfo = { contact: null, info: '' };
  ocSendTo = '';
  ocSendToInfo = { contact: null, info: '' };
  deliveryNoteSendTo = '';
  deliveryNoteSendToInfo = { contact: null, info: '' };
  testCertificateSendTo = '';
  testCertificateSendToInfo = { contact: null, info: '' };
  invoiceReminderSendTo = '';
  invoiceReminderSendToInfo = { contact: null, info: '' };

  orderData: any;

  tcSpoMap: any = [];

  messages = [];

  filteredCodes: string[] = [];
  // nrkj: BusinessModel;
  // nrka: BusinessModel;

  // clipboardList = [];

  businessGeneralInfo = ''
  
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('lineItems') lineItems: LineItemContainerComponent;
  @ViewChild('documentPrinter') documentPrinter: DocumentPrinterComponent;
  @ViewChild('reportsPrinter') reportsPrinterRef: ReportsPrinterComponent;
  @ViewChild('docSubComponents') docSubComponents: DocumentSubComponentsComponent;
  @ViewChild('reportDates') reportDates: ReportDatesComponent;
  @ViewChild('offerWizard') offerWizard: ProductWizardComponent;
  @ViewChild('recipientSelector') recipientSelector: DocFormAddressSelectorComponent;
  @ViewChild('internalUpdates') internalUpdates: NrkWindowComponent;
  // @ViewChild(NbPopoverDirective) clipboardBtn: NbPopoverDirective;
  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;
  @ViewChildren(DocFormAddressSelectorComponent) addressselectorComponents: QueryList<DocFormAddressSelectorComponent>;

  @ViewChild('profitCalc') profitCalc: ProfitMarginComponent;
  @ViewChild('profitCalcOCSPO') profitCalcOCSPO: ProfitMarginComponent;

  previewDisabled = true;

  toggleHeading: boolean = false;

  reportsSearch = null;

  srStatus: string = '';

  columnOptions = [
    { id: '', name: 'in all columns' },
    // { id: 'issuer', name: 'Issuer', search: '' },
    { id: 'code', name: 'Document number', search: '', style: {'width':'11rem' } },
    { id: 'internal', name: 'Internal [OBIC]', search: '' },
    { id: 'recipient', name: 'Recipient', search: '' },
    { id: 'customerName', name: 'Customer name', search: '' },
    { id: 'customerDocumentNumber', name: 'Customer document number', search: '' },
    // { id: 'customerPoPosition', name: 'CPos', search: '' },
    // { id: 'partialDelivery', name: 'CPD', search: '' },
    { id: 'customerDocumentDate', name: 'POD', search: '', style: {'width':'4rem','white-space':'pre-wrap','text-align':'center'} },
    { id: 'exwJapanDate', name: 'EXW', search: '', style: {'width':'4rem','white-space':'pre-wrap','text-align':'center'} },
    { id: 'arrivingVieDate', name: 'ETA', search: '', style: {'width':'4rem','white-space':'pre-wrap','text-align':'center'} },
    { id: 'dueDate', name: 'Due', search: '', style: {'width':'4.5rem','white-space':'pre-wrap','text-align':'center'} },
    { id: 'documentStatus', name: 'Status', search: '', style: {'width':'9rem','white-space':'pre-wrap'} },
    { id: 'issuedBy', name: 'Issuer', search: '', style: {'width':'4rem','text-align':'center'} },
    { id: 'updatedAt', name: 'last Upd', search: '', style: {'width':'5rem'} },
  ];
  // columns = [ ...this.columnOptions.splice(1), { id: 'ref', name: '', search: '' }];
  columns = [ ...this.columnOptions.splice(1)];

  docPage: number;
  
  loading = true;

  constructor(
    public api: ApiService,
    public data: SharedDataService,
    protected toastrService: NbToastrService,
    public cdRef: ChangeDetectorRef,
    protected route: ActivatedRoute,
    protected router: Router,
    protected dialogService: NbDialogService,
    protected datePipe: DatePipe,
    public auth: AuthGuardService,
    public tree: TreeService,
    private event: EventService,
    protected tabCoordinator: TabCoordinatorService,
    private zone: NgZone,
  ) {
    super(dialogService, api, auth, data);
  }

  prevType = 0;
  ngDoCheck(): void {
    // console.log('document ngDoCheck:>' + this.selected?.customerDocumentNumber + '<' );
    if (this.selected && this.prevType !== this.selected.type) {
      this.compilationTypeChanged(this.prevType, this.selected.type);
      this.prevType = this.selected.type;
    }
    this.previewDisabled = (this.selected?.type === CompilationTypeData.get('CS').id || this.lineItems?.lineItemsLoaded) ? null : true;

    if (this.data.warehousingMessages) {
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {  // don't re-trigger change detection
          this.messages = this.data?.warehousingMessages?.filter(f => f?.code === this.selected?.code && !f.deleted);
        })
      })
    }

    // console.log('--> sli', this.selected?.shipmentLineItems?.map(m => m.document?.customerRequestedDeliveryDate && new Date(m.document?.customerRequestedDeliveryDate)?.toISOString()?.replace(/T.*/, '')).join('\n'));
  }

  async ngOnInit() {
    this.issuer = this.route.snapshot.params.issuer && IssuerData.get(this.route.snapshot.params.issuer).id;

    this.items = this.data.compilationItems;

    await this.loadData();

    this.subscriptions.push(this.tree.documentTreeLoadedEvent.subscribe(async (tree) => {
      if (['IN', 'PFIN'].includes(CompilationTypeData.get(+this.selected.type)?.code) && !this.selected.testCertificate?.files?.length) {
        // transfer test certificates to invoice
        this.selected.testCertificate.files = this.tree.linkedPfspos?.reduce((a, c) => [...a, ...c?.testCertificates], [])
        this.selected.testCertificate.completed = this.selected.testCertificate.files?.length > 0;
      }

      this.orderData = this.data?.calcData(this.tree?.linkedOR);
      // console.log('--> sli tree loaded', this.selected?.shipmentLineItems?.map(m => m.document?.customerRequestedDeliveryDate && new Date(m.document?.customerRequestedDeliveryDate)?.toISOString()?.replace(/T.*/, '')).join('\n'));
      this.srStatus = (await this.api.getSrStatus(this.tree.linkedOC?.code))?.statusStr;

      // console.log('-->pricing container', this.selected.code, tree?.code, this.tree.linkedOC?.customerRequestedDeliveryDate, this.selected.lineItems)
      // if (this.selected.lineItems?.find(f => {
      //   const refDate = CompilationTypeData.get('OC').id === this.selected.type 
      //     ? this.selected.customerRequestedDeliveryDate
      //     : this.tree.linkedOC?.customerRequestedDeliveryDate;
      //   console.log('pricing', this.selected?.customerRequestedDeliveryDate, this.tree.linkedOC?.customerRequestedDeliveryDate, refDate);
      //   const isValid = !this.data.priceIsValid(this.selected.recipient, f.finishedProduct, refDate)

      // })) {
      //   console.log('pricing xxx', this.data.priceIsValid(this.selected.recipient, f.finishedProduct, refDate));
      //   this.selected.pricingDisclaimer = true;
      // }
      this.selected.pricingDisclaimer = !!this.selected.lineItems?.find(f => {
        const refDate = this.tree.linkedOC?.customerRequestedDeliveryDate ?? this.selected.customerRequestedDeliveryDate;
        const isValid = this.data.priceIsValid(this.selected.recipient, f.finishedProduct, refDate);
        const fp = this.data.finishedProducts?.find(s => mongoId(s) === mongoId(f.finishedProduct));
        const bu = fp?.product?.businessUnit;
        // console.log('price check....',bu.code, this.selected.code, refDate, isValid);
        if (!['EM', 'VI', 'MM', 'BT'].includes(bu?.code)) return false;
        return !isValid;
      })
      if (['OF'].includes(CompilationTypeData.get(+this.selected.type)?.code) && this.selected.offerDisclaimer === undefined) {
        this.selected.offerDisclaimer = true;
      }

    }));

    const doccode = this.route.snapshot.queryParams['code'];
    const doctype = this.route.snapshot.queryParams['doctype'];
    if (doctype) {
      const dt = CompilationTypeData.get(doctype);
      this.filter.doctype = dt ? dt.id : null;
    }
    this.filter.sort.column = 'updatedAt';
    this.filter.sort.dir = -1;

    if (doccode) {
      const doc = await this.api.loadCompilationByCode(doccode);
      if (!this.sideBarOpen) this.toggleSidebar(doc);
      if (this.route.snapshot.queryParams['preview']) this.onShowDocumentPreview();
    }

    this.readOnly = this.isReadOnly();

    this.setDisplayedItems();

    // router subscription
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd && ev.url.indexOf('/pages/erp/document') >= 0 && this.route.snapshot.params.issuer) {
        if (this.issuer !== IssuerData.get(this.route.snapshot.params.issuer).id) {
          this.issuer = IssuerData.get(this.route.snapshot.params.issuer).id;
          if (this.sideBarOpen && !this.route.snapshot.queryParams['code']) {
            this.hideSidebar();
          }
        }
        if (this.route.snapshot.queryParams['code']) {
          this.showSidebar();
          this.setCurrentDocumentByCode(this.route.snapshot.queryParams['code']);
          this.readOnly = this.isReadOnly();
          if (this.route.snapshot.queryParams['preview']) this.onShowDocumentPreview();
        }
      }
      this.setDisplayedItems();
    });

    await this.data.loadPrices();

    // this.subscriptions.push(this.tree.documentTreeStartLoadingEvent.subscribe(() => this.setLocked()));

    // if (this.issuer !== IssuerData.get('NRKA').id) {
    //   this.compilationTypeOptions = this.compilationTypeOptions.filter(f => f.id !== CompilationTypeData.get('OBIC').id);
    // }

    // await this.data.loadContacts();
    // await this.data.loadBusinesses();
    // const employees = this.data.business.nrka.contacts.filter(f => f.type === EContactType.Employee).map(m => m._id);
    // this.employeeOptions = this.data.contactOptions.filter(f => employees.includes(f.id));
    // console.log('load contacts', this.data.contacts, this.data.contactOptions, this.data.business.nrka, employees, this.employeeOptions)
  }

  showBanner = false;
  // ngAfterViewInit() {
  //   window.addEventListener(
  //     'scroll',
  //     this.onAnyScroll,
  //     { capture: true }   // IMPORTANT
  //   );
  // }

  // onAnyScroll = (event: Event) => {
  //   const target = event.target as HTMLElement;
  //   if (target.contains(this.scrollContainer?.nativeElement)) {
  //     this.showBanner = target.scrollTop > 70;
  //   }
  // };

  ngAfterViewInit() {
    // run scroll listener outside Angular to avoid triggering change detection on every scroll
    this.zone.runOutsideAngular(() => {
      window.addEventListener(
        'scroll',
        this.onAnyScroll,
        { capture: true } // IMPORTANT
      );
    });
  }

  // use an arrow function to preserve `this`
  onAnyScroll = (event: Event) => {
    const target = event.target as HTMLElement;

    if (target.contains(this.scrollContainer?.nativeElement)) {
      const scrollTop = target.scrollTop;

      // only enter Angular if the state actually changes
      if ((scrollTop > 70 && !this.showBanner) || (scrollTop <= 70 && this.showBanner)) {
        this.zone.run(() => {
          this.showBanner = scrollTop > 70;
        });
      }
    }
  };

  edit() {
    this.reportDates && this.reportDates.syncDisplayDates();
    this.lineItems && this.lineItems.syncPartialDelivery();
    super.edit();
  }

  lock(doLock: boolean) {
    this.reportDates && this.reportDates.syncDisplayDates();
    super.lock(doLock);
  }

  isReadOnly = () =>  {
    // console.log('check read only: isMasterTab:', this.tabCoordinator.isMasterTab);
    if (!this.tabCoordinator.isMasterTab) return true;
    if (!this.owner || !this.owner.erpRoles) return true;
    return (this.owner.erpRoles.readOnlyNrka && +this.issuer === IssuerData.get('NRKA').id)
    || (this.owner.erpRoles.readOnlyNrkg && +this.issuer === IssuerData.get('NRKG').id)
  }

  async loadData(reload = false, reloadTree = false) {
    this.subscriptions.forEach(el => el.unsubscribe());

    console.log('compilation: load data');
    console.time('compilation: load data');
    this.loading = true;
    const promises: Promise<any>[] = [];

    this.data.loadUsers();
    this.data.loadBusinesses().then(b => {
      this.customerReferenceOptions = [...this.data.businessOptions];
    })


    this.owner = this.auth.user;
    this.readOnly = this.isReadOnly();

    promises.push(this.data.loadBusinesses().then(() => {
      this.contactUtil = new ContactUtil(this.data);
      this.setBusinesses();
    }));

    // this.data.loadSpoBoxes();

    if (!this.data.latestVersionItems?.length) {
      this.reloadItems(true);
    } else {
      this.setDisplayedItems();
    }

    this.data.loadCompilationData().then(() => {
      // if (!this.data.compilationData.meansOfTransportStore) this.data.compilationData.meansOfTransportStore = [];
      // if (!this.data.compilationData.termsOfPaymentStore) this.data.compilationData.termsOfPaymentStore = [];
      // this.meansOfTransportOptions = this.data.compilationData.meansOfTransportStore.map(m => ({id: m, name: m}));
      this.termsOfPaymentOptions = this.data.compilationData.termsOfPaymentStore?.map(m => ({id: m, name: m}));
    });

    this.data.loadContacts();

    // promises.push(this.data.loadPalletRefs());

    promises.push(this.data.loadProducts().then(() => this.baseProducts = this.data.baseProducts.filter(f => !f.draft)));

    await Promise.all(promises).then(()=> {
      console.timeEnd('compilation: load data');
      this.lineItems?.recalc();
      this.loading = false;
      if (reloadTree && this.selected) this.tree.loadDocumentTree(this.selected);
    })

    this.api.refreshCache();

    this.subscriptions.push(this.event.receiver.subscribe(event => {
      // console.log('event', event.name)
      switch (event.name) {
        case 'packing-change':
          const result = event.data;
          // console.log('------>in compilation', result)
          // const pallet = [new PackingConditions(), new PackingConditions()];
          // pallet[0].lineItemIdx = 0;
          // pallet[0].items = [new PackingConditionItem()]
          // pallet[0].items[0].numberOfBoxes = 8
          // pallet[1].lineItemIdx = 0;
          // pallet[1].items = [new PackingConditionItem(), new PackingConditionItem()]
          // pallet[1].items[0].numberOfBoxes = 9
          // pallet[1].items[1].numberOfBoxes = 10
          // this.selected.packingConditions.push(...pallet);
          break;
        case 'tab-coordinator':
          // console.log('tabcoord', event.data);
          switch (event.data) {
            case 'masterTabEvent':
            case 'makeSlave':
              console.log('tabcoord', event.data);
              this.loadData(true, true);
              if (this.selected._id) this.setCurrentDocumentById(this.selected._id);
            break;
          }
          break;
      }
    }))

    this.subscriptions.push(this.event.issuerChange.subscribe(issuer => {
      console.log(`issuer changed ${this.issuer} => ${issuer}`);
      this.issuer = issuer;
      location.href = location.href.replace(/(nrka|nrkg)/, IssuerData.get(issuer).link)
    }));

  }

  ngOnDestroy() {
    this.subscriptions.forEach(el => el.unsubscribe());
  }

  compilationTypeChanged(prevType: number, currType: number) {
    this.data.setDocConfigMaps(currType);
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.isDirty();
  }

  async loadCompilation(id: string) {
    const cache = this.selected?.tmp;
    const doc = await this.api.loadCompilation(id)
    doc.tmp = cache;
    if (cache && this.selected) this.selected.tmp = cache;
    // console.log('loadCompilation', this.selected.notInInvoiceReport);
    return doc;
  }

  async loadCompilationByCode(code: string, version = null) {
    const cache = this.selected?.tmp;
    // console.log('loadCompilationByCode', this.selected.notInInvoiceReport);
    const doc = await this.api.loadCompilationByCode(code, version);
    if (doc) doc.tmp = cache;
    this.selected.tmp = cache;
    
    return doc
  }

  // ====================================== page container ===================================================

  getItemString(item, col, internal = false) {
    if (item[col] instanceof Date) item[col] = item[col].toISOString();
    switch (col) {
      case 'code':
        return internal ? getDocumentNumber(item) : getDocumentNumber(item)?.replace(/VS.*/, '');
      case 'recipient':
        const r = item[col]; if (r) return r.name; break;
      case 'issuer':
        const i = IssuerData.get(item[col]); if (i) return ''+i.name; break;
      case 'documentStatus':
        // const transportStatus = (item.type === 16 || item.type === 6) && item.transportRun ? TransportStatusData.get(item.transportRun.transportStatus).name : '';
        // const status = this.getSelected(item.documentStatus, DocumentStatusData.getOptions() as any);
        // return transportStatus ? `${status}\n${transportStatus}` : status;
        const ocStatus = ['OC'].includes(this.typeData.get(item.type).code) 
          ? item.completelyInvoiced 
            ? ', invoiced' 
            : ', not invoiced'
          : '';
        const docStatus = DocumentStatusData.get(item[col])?.name?.replace(/cancelled/, 'canc.');
        const dnStatus = ['DN'].includes(this.typeData.get(item.type).code) && item.packingStatus ? ', ' + PackingStatusData.get(item.packingStatus)?.short : '';
        const inStatus = ['IN', 'PFIN'].includes(this.typeData.get(item.type).code) && item.invoiceStatus ? ', ' + InvoiceStatusData.get(item.invoiceStatus)?.name : '';
        const spoStatus = ['SPO', 'PFSPO'].includes(this.typeData.get(item.type).code)
          ? item.transportRun.spoStatus >= 0
            ? ', ' + SpoStatusData.get(item.transportRun.spoStatus)?.code
            : ''
          : '';
        const transportStatus = ['CS', 'SPO', 'PFSPO'].includes(this.typeData.get(item.type).code) && item.transportRun ? '\n' + TransportStatusData.get(item.transportRun.transportStatus).name : '';
        return docStatus + ocStatus + dnStatus + inStatus + spoStatus + transportStatus;
      case 'internal':
        return (item.internal || '') + (!/^CS/.test(item.code) && item.obics?.length ? ` [${item.obics.join('; ')}]` : '');
      case 'partialDelivery':
        const pd = item[col]; if (pd?.el && pd.of) return pd.el + ' / ' + pd.of; break;
      case 'issuedBy':
        // return this.getSelected(item.issuedBy, this.data.userOptions);
        return this.data.userShort(item.issuedBy);
      case 'customerDocumentDate':
        return internal ? item[col]?.replace(/T.*/,'') : item[col]?.replace(/T.*/,'')./*replace(/-/g,'·').*/replace(/^(....)./, '$1\n');
      case 'exwJapanDate':
      case 'arrivingVieDate':
        // return /(CS|SPO)NRK.*/.test(item['code']) ? item[col]?.replace(/T.*/, '') : '';
        return internal 
          ? /(CS|SPO)NRK.*/.test(item.code) 
            ? item[col]?.replace(/T.*/,'')
            : ''
          : /(CS|SPO)NRK.*/.test(item.code) 
            ? item[col]?.replace(/T.*/,'')./*replace(/-/g,'·').*/replace(/^(....)./, '$1\n')
            : '';
      case 'dueDate':
        if (typeof item[col]?.replace !== 'function') return '';
        return internal ? item[col]?.replace(/T.*/,'') : item[col]?.replace(/T.*/,'')?./*replace(/-/g,'·').*/replace(/^(....)./, '$1\n');
      case 'updatedAt':
        return item[col]?.replace(/T/,' ').replace(/....Z/, '').replace(/-/g,'·').replace(/^../, '');
      default: return item[col] || '';
    }
  }

  filterItem(item, col, search) {
    const cmp = diacriticless(this.getItemString(item, col, true));
    const ret = cmp?.toLowerCase().includes(diacriticless(search));
    // if (/^CS/.test(item.code) && col === 'internal') { // search for combined shipment obics (not displayed in gui)
    //   // return (ret + item.obics?.join().toLowerCase()).includes(search?.toLowerCase());
    //   return (this.getItemString(item, col) + item.obics?.join()).toLowerCase().includes(search?.toLowerCase());
    // }
    return ret;
  }

  clearFilter() {
    this.columns.forEach(el => el.search = '');
    this.filteredCodes = [];
  }

  setBusinesses(fromTemplate = false) {

    const separator = new BusinessModel();
    separator._id = nrkHrDummyId;
    const sepopt = { id: nrkHrDummyId, name: '' };
    const recipient = this.data.businesses.find(f => f._id === mongoId(this.selected.recipient));
    this.businessGeneralInfo = recipient?.generalInfo;
    const cref = this.data.businesses.find(f => f._id === mongoId(this.selected.customerReference));
    // const nrt = this.data.businesses.find(f => /^NRT$/i.test(f.name));
    // const micamation = this.data.businesses.find(f => /^Micamation$/i.test(f.name));
    // const nrvi = this.data.businesses.find(f => /^NRVI$/i.test(f.name));
    // const bartech = this.data.businesses.find(f => /^NRBM$/i.test(f.name));
    // this.nrka = this.data.businesses.find(f => /^NRKA$/i.test(f.name));
    // const nrkg = this.data.businesses.find(f => /^NRKG$/i.test(f.name));
    // const ceva = this.data.businesses.find(f => /^CEVA.*Airport/i.test(f.name));
    // this.nrkj = this.data.businesses.find(f => /^NRKJ$/i.test(f.name));
    // const nrkv = this.data.businesses.find(f => /^NRKV$/i.test(f.name));
    // const dhl = this.data.businesses.find(f => /^DHL /.test(f.name));

    // const pfspcda = mongoId(cref) !== mongoId(recipient)
    //   && this.selected.type === CompilationTypeData.get('PFSPC').id ? [cref] : [];
    let pfspcda = [];
    let recipientPre = [];
    // if (this.selected.type === CompilationTypeData.get('PFSPO').id) {
    //   recipientPre = [this.nrkj, separator];
    // } else if (this.selected.type === CompilationTypeData.get('PFSPC').id) {
    //   recipientPre = [this.nrka, nrkg, this.nrkj, separator];
    // } else if (this.selected.type === CompilationTypeData.get('SPC').id) {
    //   recipientPre = [ceva, dhl, separator];
    // }

    const b = this.data.business;

    switch (this.selected.type) {
      case CompilationTypeData.get('TOF').id:
        recipientPre = [...this.data.businesses.filter(b => b.type === EBusinessType.Template), separator];
        break;
      case CompilationTypeData.get('SPO').id:
        recipientPre = [b.nrvi, b.nrkv, b.micamation, b.bartech, b.ceva, separator];
        if (mongoId(cref) !== mongoId(recipient)) pfspcda = [cref];
        break;
      case CompilationTypeData.get('SPC').id:
        recipientPre = [b.ceva, b.dhl, separator];
        break;
      case CompilationTypeData.get('PFSPO').id:
        recipientPre = [b.nrkj, separator];
        break;
      case CompilationTypeData.get('PFSPC').id:
        recipientPre = [b.nrka, b.nrkg, b.nrkj, separator];
        break;
      case CompilationTypeData.get('OC').id:
        if (mongoId(recipient) === mongoId(b.nrkg)) this.selected.completelyInvoiced = true;
        break;
      case CompilationTypeData.get('OR').id:
        const generalContact = this.contactUtil.getGeneralContact(recipient);
        if (!this.selected.taxHint && CountryCodes.isEU(generalContact?.fields?.find(f => f.type === EContactFieldType.Country)?.value)) {
          this.selected.taxHint = 'Not taxable in Austria. Tax free intracommunity dispatch following sec 6 VAT Act';
        }
        break;
      // case CompilationTypeData.get('DN').id:
      //   this.selected.receptionHours = this.contactUtil.getContactField(mongoId(this.selected.recipient), EContactFieldType.ReceptionHours, EContactType.DNSendTo);
      //   break;

    }

//    console.log('setBusinesses', this.selected.receptionHours, recipient, this.selected.receptionHours)

    this.recipientBusinesses = [...recipientPre, ...this.data.businesses];
    this.deliveryBusinesses = [...pfspcda, b.ceva, recipient, b.nrka, b.jerich, separator, ...this.data.businesses];
    this.manufacturerBusinesses = [b.nrt, b.micamation, b.nrvi, b.bartech, b.nrkv, separator, ...this.data.businesses];
    this.importerBusinesses = [b.nrka, b.nrkg, separator, ...this.data.businesses];
    this.placeOfLoadingBusinesses = [b.ceva, b.nrt, b.nrka, b.nrkv, b.nrvi, b.jerich, recipient, separator, ...this.data.businesses];
    const name = recipient && recipient.name;
    if (recipient) {
      this.customerReferenceOptions
        = [{ id: recipient._id, name: name }, sepopt, ...this.data.businessOptions];
    }

    if (recipient && this.data.visibleMap.notInInvoiceReport && fromTemplate && /^NRKG$/i.test(recipient.name)) {
      this.selected.notInInvoiceReport = true;
    }
    if (recipient && this.data.visibleMap.notInOrderReport && fromTemplate && /^NRKG$/i.test(recipient.name)) {
      this.selected.notInOrderReport = true;
    }

    if (mongoId(this.selected.recipient) === mongoId(b.nrkg)) {
      this.selected.isInternalDocument = true;
    }

    this.selected.accountManager = ((this.data.businesses.find(b => b._id === mongoId(this.selected.recipient))?.manager) as ContactModel)?.title || '';

    // const rh = recipient && this.contactUtil.getGeneralContact(mongoId(recipient))
    //   .fields.find(f => +f.type === +EContactFieldType.ReceptionHours);

    // this.selected.receptionHours = rh && rh.value;

    if (+this.selected.type === CompilationTypeData.get('OF').id) {
      // console.log('recipient change user:', this.selected.recipient, this.data.getBusinessManagerUser(this.selected.recipient))
      this.onIssuerContactChanged(this.data.getBusinessManagerUser(this.selected.recipient));
    }

    // const inInstructions = this.contactUtil.getContactField(this.selected.recipient, EContactFieldType.Instructions, EContactType.InvoiceSendTo);
    this.invoiceSendTo = this.contactUtil.getAddressFromBusiness(
      mongoId(this.selected.recipient), 
      DocConfig.get('sendToInfo').fields, 
      EContactType.InvoiceSendTo,
      false
    )
    const conist = this.data.businesses.find(f => f._id === mongoId(this.selected.recipient))?.contacts?.find(f => f.type === EContactType.InvoiceSendTo);
    this.invoiceSendToInfo = {
      contact: conist,
      info: conist?.fields?.find(f => f.type === EContactFieldType.Info)?.value
    }

    this.ocSendTo = this.contactUtil.getAddressFromBusiness(
      mongoId(this.selected.recipient), 
      DocConfig.get('sendToInfo').fields, 
      EContactType.OCSendTo,
      false
    )
    const conost = this.data.businesses.find(f => f._id === mongoId(this.selected.recipient))?.contacts?.find(f => f.type === EContactType.OCSendTo);
    this.ocSendToInfo = {
      contact: conost,
      info: conost?.fields?.find(f => f.type === EContactFieldType.Info)?.value
    }

    // const dnInstructions = this.contactUtil.getContactField(this.selected.recipient, EContactFieldType.Instructions, EContactType.DNSendTo);
    this.deliveryNoteSendTo = this.contactUtil.getAddressFromBusiness(
      mongoId(this.selected.recipient), 
      DocConfig.get('sendToInfo').fields, 
      EContactType.DNSendTo,
      false
    )
    const condst = this.data.businesses.find(f => f._id === mongoId(this.selected.recipient))?.contacts?.find(f => f.type === EContactType.DNSendTo);
    this.deliveryNoteSendToInfo = {
      contact: condst,
      info: condst?.fields?.find(f => f.type === EContactFieldType.Info)?.value
    }

    // const tcInstructions = this.contactUtil.getContactField(this.selected.recipient, EContactFieldType.Instructions, EContactType.TCSendTo);
    this.testCertificateSendTo = this.contactUtil.getAddressFromBusiness(
      mongoId(this.selected.recipient), 
      DocConfig.get('sendToInfo').fields, 
      EContactType.TCSendTo,
      false
    )
    const contst = this.data.businesses.find(f => f._id === mongoId(this.selected.recipient))?.contacts?.find(f => f.type === EContactType.TCSendTo);
    this.testCertificateSendToInfo = {
      contact: contst, 
      info: contst?.fields?.find(f => f.type === EContactFieldType.Info)?.value
    }

    this.invoiceReminderSendTo = this.contactUtil.getAddressFromBusiness(
      mongoId(this.selected.recipient), 
      DocConfig.get('sendToInfo').fields, 
      EContactType.InvoiceReminder,
      false
    )
    const conirst = this.data.businesses.find(f => f._id === mongoId(this.selected.recipient))?.contacts?.find(f => f.type === EContactType.InvoiceReminder);
    this.invoiceReminderSendToInfo = {
      contact: conirst,
      info: conirst?.fields?.find(f => f.type === EContactFieldType.Info)?.value
    }
    // console.log('SEND TO', this.invoiceSendTo, this.deliveryNoteSendTo, this.testCertificateSendTo, this.selected.invoiceSendTo);

    // console.log('initial setBusiness', this.selected.nrkjOverride ? this.getAddress(null) : 'nrka/g', this.selected.nrkjOverride, this.selected.issuerAddress);

  }


  saveBusinessSendToInfo(sendToStruct: { contact: ContactModel, info: string }) {
    console.log('saveBusinessSendToInfo', sendToStruct);
    const field = sendToStruct.contact.fields.find(f => f.type === EContactFieldType.Info);
    if (!field) {
      sendToStruct.contact.fields.push({ type: EContactFieldType.Info, value: sendToStruct.info });
    } else {
      field.value = sendToStruct.info;
    }
    this.api.saveContact(sendToStruct.contact);
  }

  // async saveBusinessGeneralInfo() {
  //   return new Promise((res, rej) => {
  //     this.api.loadBusiness(mongoId(this.selected.recipient)).subscribe(business => {
  //       console.log('general business pre save', business);
  //       business.generalInfo = this.businessGeneralInfo;
  //       this.api.saveBusiness(business).subscribe(() => {
  //         console.log('general business post save1', business);
  //         this.data.reloadBusinesses();
  //         console.log('general business post save2', business);
  //         this.toastrService.success('General info successfully updated', business.name);
  //         res(true);
  //       });
  //     })
  //   })
  // }
  
  async saveBusinessGeneralInfo() {
    const business = await firstValueFrom(
      this.api.loadBusiness(mongoId(this.selected.recipient))
    );

    business.generalInfo = this.businessGeneralInfo;

    await firstValueFrom(
       this.api.saveBusiness(business)
    );

    this.data.reloadBusinesses();
    this.toastrService.success(
      'General info successfully updated',
      business.name
    );
  }

  setDNBusinessFields(business: BusinessModel) {
    this.data.setCSIdentifier(this.selected);
    this.selected.receptionHours = this.contactUtil.getContactField(mongoId(business), EContactFieldType.ReceptionHours, EContactType.Delivery);
    // console.log('setDNBusinessFields', this.selected.recipient, this.selected.receptionHours);

    // const recipient = this.data.businesses.find(f => mongoId(f) === mongoId(this.selected.deliveryRecipient));
    // console.log('dnBoxTable', recipient?.dnBoxTable, this.selected.visibleFields, business, this.selected);
    // if (
    //   recipient?.dnBoxTable 
    //   && this.selected.type === CompilationTypeData.get('DN').id
    //   && !this.selected.visibleFields.includes('dnBoxes')
    //   && this.selected.draft
    // ) {
    //   this.selected.visibleFields.push('dnBoxes');
    //   console.log('dnBoxes pushed');
    // }
    // console.log('dnBoxTable2', recipient?.dnBoxTable, this.selected.visibleFields);

  }


  setDisplayedItems() {

    let ret = [];
    if (this.isOffersPage()) {
      const assocBusinesses = this.data.businesses && this.data.businesses
        .filter(f => mongoId(f.manager) === mongoId(this.auth.user.contact))
        .map(m => mongoId(m));
      ret = this.data.businesses && this.data.latestVersionItems?.filter(f =>
        (this.templatesOnly ? ['TOF'] : ['TOF', 'OF']).includes(CompilationTypeData.get(f.type)?.code)
        && (
          f.documentStatus === DocumentStatusData.get('final').id
          || (
            f.documentStatus === DocumentStatusData.get('draft').id
            && mongoId(f.issuedBy) === mongoId(this.owner)
          )
        )
        && (
          this.auth.user.erpRoles.offers === 1 || (this.auth.user.erpRoles.offers === 3 && assocBusinesses.includes(mongoId(f.recipient)))
        )
      )
    } else {
      ret = this.data.latestVersionItems && this.data.latestVersionItems.filter(f => {
        return (!this.filter.doctype || this.filter.doctype === f.type)
        && f.type !== CompilationTypeData.get('TOF').id
        && this.issuer === f.issuer
        && (!this.filter.draftsOnly || (this.filter.draftsOnly && f.draft))
        && (!this.readOnly || (this.readOnly && ! f.draft))
        && (!this.filter.recipient || this.filter.recipient == mongoId(f.recipient))
        && (this.filter.doctype !== 1 || !f.offerData || this.filter.offerStatus.includes(f.offerData.offerStatus))
        && (!this.filter.obic || !this.filter.obic.length || (f['obics'] && f['obics'].find(o => new RegExp(this.filter.obic, 'i').test(o))))
        // && (!this.filter.accountManager || this.filter.accountManager == mongoId((this.data.businesses.find(b => b._id === mongoId(f.recipient))?.manager)))
        && (!this.filter.lot || this.filteredCodes.includes(f.code))
        && (!this.filter.tcNumber || this.filteredCodes.includes(f.code))
        && (!this.filter.poDateFrom || (f.customerDocumentDate >= this.filter.poDateFrom))
        && (!this.filter.poDateTo || (f.customerDocumentDate <= this.filter.poDateTo))
        && (!this.filter.exwDateFrom || (['SPO', 'PFSPO'].includes(this.typeData.get(f.type)?.code) && f.exwJapanDate >= this.filter.exwDateFrom))
        && (!this.filter.exwDateTo || (['SPO', 'PFSPO'].includes(this.typeData.get(f.type)?.code) && f.exwJapanDate <= this.filter.exwDateTo))
        && (!this.filter.etaDateFrom || (['SPO', 'PFSPO'].includes(this.typeData.get(f.type)?.code) && f.arrivingVieDate >= this.filter.etaDateFrom))
        && (!this.filter.etaDateTo || (['SPO', 'PFSPO'].includes(this.typeData.get(f.type)?.code) && f.arrivingVieDate <= this.filter.etaDateTo))
        && (!this.filter.dueDateFrom || (['IN', 'PFIN'].includes(this.typeData.get(f.type)?.code) && f.dueDate >= this.filter.dueDateFrom))
        && (!this.filter.dueDateTo || (['IN', 'PFIN'].includes(this.typeData.get(f.type)?.code) && f.dueDate <= this.filter.dueDateTo))
      });
    }

    if (this.columns.find(f => f.search.length)) {
      this.columns.forEach(col => {
        if (col.search.length) {
          const s = col.search.toLowerCase();
          ret = ret.filter(field => this.filterItem(field, col.id, s));
        }
      });
    }

    this.compilationTypeOptions = CompilationTypeData.getOptions().filter(f => 
      this.issuer === IssuerData.get('NRKA').id || f.id !== CompilationTypeData.get('OBIC').id
    )

    this.displayedItems = ret;
  }

  onSort(col) {
    if (col === this.filter.sort.column) {
      this.filter.sort.dir = - this.filter.sort.dir;
    } else if (col) {
      this.filter.sort.column = col;
    }

    this.displayedItems = this.displayedItems?.sort((a, b) => {
      const ac = this.getItemString(a, this.filter.sort.column) || '';
      const bc = this.getItemString(b, this.filter.sort.column) || '';
      return this.filter.sort.dir * ac.toLowerCase().localeCompare(bc.toLowerCase());
    });
  }

  async reloadItems(preload = false) {
    // if (preload) {
    //   this.items = await this.data.reloadCompilationItems(true);
    //   this.data.latestVersionItems = this.getCurrentItems(this.items, true)
    //     .sort((a, b) => a['updatedAt'] < b['updatedAt'] ? 1 : -1)
    //   this.setDisplayedItems();
    // } else {
    //   this.data.reloadCompilationItems(false).then(items => {
    //     this.items = items;
    //     this.data.latestVersionItems = this.getCurrentItems(this.items, true)
    //       .sort((a, b) => a['updatedAt'] < b['updatedAt'] ? 1 : -1)
    //     this.setDisplayedItems();
    //   })
    // }
    this.items = this.data.compilationItems = [];
    this.data.compilationItems = this.items;
    const len = 50;
    const load = (from: number, len: number) => {
      this.data.reloadCompilationItems(from, len).then(comp => {
        if (!comp?.length) return;
        this.setDisplayedItems();
        load(from + len, len+50);
        this.onSort(null);
      })
    }
    load(0, len);
  }

  // ===================================== document creation / storage ===========================================

  async onCloneDocument(attached: boolean) {
    // this.canDismiss(this.selected).then(res => {
    //   if (res && !this.selected._id) {
    //     this.removeItem(this.selected);
    //   }
    //   if (res) this.doCreateDocument(this.selected.type, 'all', false, false, attached);
    // });
    const internalDoc = ['SPO', 'PFSPO'].includes(CompilationTypeData.get(this.selected.type).code);
    const maxDays = 365; //internalDoc ? 364 : 90;
    const docDate = moment(this.selected.firstDate?.issueDate || this.selected.issueDate);
    const thisYear = internalDoc || moment().year() === docDate.year()
    const tooOld = moment().diff(docDate, 'days') > maxDays;

    // console.log('date diff, docDat', docDate.year(), moment().year(), docDate.diff(moment(), 'days'))

    if ( !['OF', 'SPO', 'PFSPO', 'CS', 'DN'].includes(CompilationTypeData.get(this.selected.type).code) && (!thisYear || tooOld) ) {
      this.dialogService.open(CommonDialogComponent, {
        context: {
          // message: `${internalDoc ? '(PF)SPOs' : 'Documents not created in ' + moment().year() + ' or' } elder than ${maxDays} days can't be cloned\nThis document was first issued on ${docDate.format('YYYY-MM-DD')}`,
          message: `${internalDoc ? '(PF)SPOs' : 'Documents issued prior to ' + moment().year() + '-01-01 or' } older than 90 days cannot be cloned. This document was issued on ${docDate.format('YYYY-MM-DD')}.  `,
        }
      })
    } else {
      this.doCreateDocument(this.selected.type, 'all', false, false, attached);
    }

  }

  async onNewDocument(type: number, toggle = true) {
    // this.canDismiss(this.selected).then(res => {
    //   if (res && !this.selected._id) {
    //     this.removeItem(this.selected);
    //   }
    //   if (res) {
    //     this.doCreateDocument(type, 'empty', false);
    //     super.toggleSidebar(this.selected);
    //   }
    // });
    this.selected.issuer = this.issuer;
    this.selected.parent = null;
    this.tree.clear();
    await this.doCreateDocument(type, 'empty', false);
    if (toggle) super.toggleSidebar(this.selected);
  }

  onCreateNewDocument(type: number, fill: string, downstreamDoc = true) {
    this.canDismiss(this.selected).then(async res => {
      if (res && type === CompilationTypeData.get('OR-NRKA').id) {
        this.createNrkaOrderFromNrkg(this.selected.code, fill);
      } else if (res && type === CompilationTypeData.get('OC-NRKG').id) {
        this.createNrkgOcFromNrka(this.selected.code, fill);
      } else if (res) {
        await this.doCreateDocument(type, fill, downstreamDoc);
      }
    });
  }

  createNrkaOrderFromNrkg(code: string, fill: string) {
    return new Promise(res =>
      this.dialogService.open(CommonDialogComponent, {
        closeOnBackdropClick: false,
        context: {
          dialogType: NrkDialogType.pfcsponrkg,
          vatOptions: this.vatPercentOptions,
          businessOptions: this.data.businessOptions,
          orderOptions: this.data.latestVersionItems
            .filter(f => +f.issuer === 3 && +f.type === CompilationTypeData.get('OR').id)
            .map(m => ({ id: m._id, name: m.code })),
          deliveryConditions: SpoChoice.fromParent,
          termsOfPayment: SpoChoice.noCommervialValue,
          inheritPrice: InheritPriceOption.keep,
        },
      }).onClose.subscribe(async x => {
        if (x) {
          this.issuer = IssuerData.get('NRKA').id;
          this.selected.issuer = this.issuer;
          this.selected.recipient = x.businessId = this.data.businesses.find(f => f.name === 'NRKG');
          this.selected.recipientAddress = this.contactUtil.getAddressFromBusiness(mongoId(this.selected.recipient));
          this.onIssuerChanged(this.issuer);
          if (fill) await this.doCreateDocument(CompilationTypeData.get('OR').id, fill, false);
          this.setInitialDocumentData(this.selected, x);
          this.selected.pfspcCode = code;
          this.router.navigate(['/pages/erp/document/nrka']);
          res(true);
        }
        res(false);
      })
    );
  }

  createNrkgOcFromNrka(code: string, fill: string) {
    return new Promise(res =>
      this.dialogService.open(CommonDialogComponent, {
        closeOnBackdropClick: false,
        context: {
          dialogType: NrkDialogType.nrkaOrSelect,
          vatOptions: this.vatPercentOptions,
          businessOptions: this.data.businessOptions,
          orderOptions: this.data.latestVersionItems
            .filter(f => +f.issuer === 3 && +f.type === CompilationTypeData.get('OR').id)
            .map(m => ({ id: m._id, name: m.code })),
        },
      }).onClose.subscribe(async x => {
        if (x) {
          this.issuer = IssuerData.get('NRKG').id;
          this.selected.issuer = this.issuer;
          const parent = await this.api.loadCompilation(x.order);
          this.selected.code = parent.code;
          this.onIssuerChanged(this.issuer);
          if (fill) await this.doCreateDocument(CompilationTypeData.get('OC').id, fill, true);
          x.businessId = parent.recipient;
          this.selected.deliveryConditions = parent.deliveryConditions;
          this.selected.paymentPlan = parent.paymentPlan;
          this.setInitialDocumentData(this.selected, x);
          this.selected.recipientContact = parent.recipientContact;
          this.selected.ocCode = code;
          this.router.navigate(['/pages/erp/document/nrkg']);
          res(true);
        }
        res(false);
      })
    );
  }

  onCreateNrkaDocFromNrkg(createDoc: string) {
    this.issuer = IssuerData.get('NRKA').id
    this.router.navigate(['/pages/erp/document/nrka']);
    this.onIssuerChanged(this.issuer);
    if (['PFIN', 'SPO'].includes(createDoc)) {
      let business;
      switch (createDoc) {
        case 'PFIN': 
          business = this.data.businesses.find(f => /^NRKG$/i.test(f.name));
          this.selected.nrkgIn = [this.selected.code];
          break;
        case 'SPO':
          business = this.data.businesses.find(f => /^NRKV$/i.test(f.name));
          break;
      }
      this.selected.recipient = business;
      this.selected.recipientContact = '';
      this.setInitialDocumentData(this.selected, { businessId: business })
    }
    this.selected.issuer = 2;
    this.doCreateDocument(CompilationTypeData.get(createDoc).id, 'all', false);
  }

  async onCreateParentObic() {

    if (this.selected.lineItems.length > 1) {
      this.toastrService.danger('OBIC documents can only have one line item', 'One line item only');
    } else if (this.selected.parent) {
      this.toastrService.danger('Document is not detached from parent', '(PF)SPO not detached');
    } else {
      const spo = await this.api.loadCompilationByCode(this.selected.code);
      await this.doCreateDocument(CompilationTypeData.get('OBIC').id, 'all');
      this.selected.parent = null;
      this.selected.draft = false;
      await this.saveItem(this.selected, false, true);
      spo.parent = this.selected.code;
      this.api.saveCompilation(spo);
      this.data.latestVersionItems.find(f => f.code === spo.code).parent = spo.parent;
      this.downstreamDocuments = this.getDownstreamDocuments(this.selected.code, true);
      if (this.selected.lineItems[0]?.tbCode) this.selected.nameOverride = this.selected.lineItems[0]?.tbCode;
    }
  }

  // onCreateNrkaPfspoFromNrkgOrderOrOc() {
  //   this.issuer = this.selected.issuer = IssuerData.get('NRKA').id
  //   this.router.navigate(['/pages/erp/document/nrka']);
  //   this.doCreateDocument(CompilationTypeData.get('PFSPO').id, 'all', false);
  // }

  // onCreateNrkaPfinFromNrkgIn() {
  //   this.issuer = this.selected.issuer = IssuerData.get('NRKA').id
  //   this.router.navigate(['/pages/erp/document/nrka']);
  //   const nrkg = this.data.businesses.find(f => /^NRKG$/i.test(f.name));
  //   this.selected.recipient = nrkg;
  //   this.selected.recipientContact = '';
  //   this.setInitialDocumentData(this.selected, { businessId: nrkg })
  //   this.doCreateDocument(CompilationTypeData.get('PFIN').id, 'all', false);
  // }

  // onCreateNrkaSpcFromNrkgPlDn() {

  // }

  async doCreateRemainigDocuments(compilation: CompilationModel, type: number, downstreamLineItems: DownstreamLineItems) {
    const lineItems = downstreamLineItems.lineItems;
    const split = downstreamLineItems.split;
    let downstream = true;

    if (type === CompilationTypeData.get('OR-NRKA').id) {
      type = CompilationTypeData.get('OR').id
      downstream = false;
      await this.createNrkaOrderFromNrkg(this.selected.code, null);
    } else if (type === CompilationTypeData.get('OC-NRKG').id) {
      type = CompilationTypeData.get('OC').id
      await this.createNrkgOcFromNrka(this.selected.code, null);
    }

    if (split && lineItems.length) {
      await this.doCreateDocument(type, [(lineItems as any)[0]], downstream, false, false);
      for (let idx = 0; idx < lineItems.length; idx++) {
        this.selected.code = await this.getCalculatedCode(this.selected, true);
        this.selected.lineItems = [lineItems[idx]];
        if (this.selected.type === CompilationTypeData.get('OC').id) {
          this.selected.customerAcceptedDeliveryDate = this.selected.customerRequestedDeliveryDate = this.selected.lineItems[0].dateOfDelivery;
        }
        await this.api.saveCompilation(this.selected);
      }
      this.reloadItems();
      this.hideSidebar();
    } else {
      await this.doCreateDocument(type, lineItems, downstream, false, false);
      await this.saveItem(this.selected, true);
      this.setCurrentDocument(this.selected);
    }
  }

  async setInitialDocumentData(doc: CompilationModel, data) {

    if (data.businessId) {
      doc.recipient = data.businessId;
      this.setBusinesses();
      doc.recipientAddress = this.contactUtil.getAddressFromBusiness(data.businessId);
      if (mongoId(this.data.business.nrvi) === mongoId(doc.recipient)     // SPO -> NRVI
        && doc.type === CompilationTypeData.get('SPO').id) {

        doc.taxHint = 'Intracommunity triangular transaction, VAT l.*Airportiability rests with service recipient';
      } else if (mongoId(this.data.business.nrkv) === mongoId(data.businessId)) {    // SPO -> NRKV
        doc.deliveryRecipient = mongoId(this.data.business.jerich);
        doc.deliveryAddress = this.contactUtil.getAddressFromBusiness(this.data.business.jerich);
        doc.placeOfLoadingRecipient = mongoId(this.data.business.nrkv);
        doc.placeOfLoading = this.contactUtil.getAddressFromBusiness(this.data.business.nrkv);
        doc.currency = 'USD';
      }
    }

    doc.attachToOC = data.attachToOC;

    if (!doc.paymentPlan) doc.paymentPlan = new PaymentPlan();
    const deliveryConditions = Object.assign({}, doc.deliveryConditions);
    const termsOfPayment = doc.paymentPlan.termsOfPayment;

    const generalContact = this.contactUtil.getGeneralContact(data.businessId);
    switch (data.deliveryConditions) {
      case SpoChoice.fromRecipinet:
        if (data) this.setBusinessFields(null, doc, 'deliveryConditions', generalContact); break;
      case SpoChoice.fromParent: doc.deliveryConditions = deliveryConditions; break;
      case SpoChoice.empty: doc.deliveryConditions = new DeliveryConditions(); break;
    }

    if (doc.type === CompilationTypeData.get('PFSPO').id) {
      doc.deliveryRecipient = mongoId(this.data.business.nrka);
      // doc.deliveryAddress = this.contactUtil.getAddressFromBusiness(mongoId(doc.deliveryRecipient));
      doc.deliveryRecipient = mongoId(this.data.business.jerich);
      doc.deliveryAddress = this.contactUtil.getAddressFromBusiness(this.data.business.jerich);
      doc.placeOfLoadingRecipient = mongoId(this.data.business.nrt);
      doc.placeOfLoading = this.contactUtil.getAddressFromBusiness(mongoId(doc.placeOfLoadingRecipient));

      doc.deliveryConditions.incoterms = 'DAP';
      doc.deliveryConditions.country = 'Austria';
      doc.deliveryConditions.place = '8200 Hofstätten an der Raab';

      // override delivery conditions
      if (this.selected.type === CompilationTypeData.get('OR').id && this.selected.sampleRequest) {
        doc.deliveryConditions.incoterms = 'EXW';
        doc.deliveryConditions.place = '321-0214 Tochigi';
        doc.deliveryConditions.country = 'Japan';
      }
    }
    if (doc.type === CompilationTypeData.get('SPO').id && mongoId(doc.recipient) === mongoId(this.data.business.nrkv)) {
      doc.deliveryConditions.incoterms = 'EXW';
      doc.deliveryConditions.country = 'Vietnam';
      doc.deliveryConditions.place = 'Ho Chi Minh City';
    }

    switch (data.termsOfPayment) {
      case SpoChoice.fromRecipinet:
        if(data) this.setBusinessFields(null, doc, 'termsOfPayment', generalContact); break;
      // eslint-disable-next-line max-len
      case SpoChoice.fromParent: doc.paymentPlan.termsOfPayment = termsOfPayment; break;
      case SpoChoice.empty: doc.paymentPlan.termsOfPayment = null; break;
      case SpoChoice.noCommervialValue: doc.paymentPlan.termsOfPayment
        = 'NO COMMERCIAL VALUE - CUSTOMS PURPOSE ONLY'; break;
    }

    switch (data.price) {
      case InheritPriceOption.zero:
        // this.selected.lineItems.forEach(el => el.piecePrice = el.displayUnitPrice = 0); break;
        doc.lineItems.forEach(el => el.piecePrice = el.displayUnitPrice = 0); break;
      case InheritPriceOption.update: setTimeout(() => this.lineItems.updateAllPrices(), 1000); break;
      case InheritPriceOption.keep: break;
    }

    doc.vatGlobal = data.vat;
    doc.lineItems?.forEach(li => li.VATPercent = data.vat);
    // this.reloadContacts();
    doc.paymentPlan.recipientUID = this.contactUtil.getContactInfoFromBusiness(data.businessId, DocConfig.get('recipientUID').fields);
    doc.receptionHours = this.contactUtil.getGeneralContact(data.businessId)?.fields.find(f => +f.type === +EContactFieldType.ReceptionHours)?.value || '';

  }

  async setDataTransfer(type: number, doc: CompilationModel, showSpoDialog = true, spoDialogRecipientId = null) {
    doc.nameOverride = null;
    doc.firstDate = new FirstDate();
    if (['OC'].includes(CompilationTypeData.get(+type).code)) {
      doc.projectRemark = this.selected.projectRemark;
    } else if (['SPC', 'PFSPC'].includes(CompilationTypeData.get(+type).code)) {
      if (doc.paymentPlan) doc.paymentPlan.termsOfPayment = null;
      if (+type === CompilationTypeData.get('PFSPC').id && this.issuer === IssuerData.get('nrkg').id) {
        doc.taxHint = 'Innergemeinschaftliche Lieferung, steuerfrei gemäss § 6a Abs. 1 UStG.'
      }
    } else if (['SPO', 'PFSPO'].includes(CompilationTypeData.get(+type).code)) {
      // doc.internal = null;
      doc.exwDate = null;
      doc.tbCode = null;
      doc.deliveryAddress = null;
      doc.placeOfLoading = null;
      doc.serviceProvided = null;
      doc.importerInfo = null;
      doc.lineItems.forEach(el => {
        el.quantity = null;
      })
      doc.taxHint = null;
      doc.deliveryDate = null;
      doc.dateOfDelivery = doc.dateOfDispatch = doc.dateOfService = doc.exwDate = null;
      doc.legacyDateOfDelivery = doc.legacyDateOfDispatch = doc.legacyDateOfService = null;
      doc.supplierReference = null;
      doc.meansOfTransport = null;
      doc.contractCondition = null;
      doc.generalText = doc.warranty = doc.validity = null;
      doc.packingConditions = [];
      doc.paymentPlan.items = [];
      doc.paymentPlan.text = null;
      doc.files = [];
      doc.documentsInternal = [];
      doc.commercialTerms = null;
      doc.transferOfOwnership = null;
      doc.relatedDocuments = null;
      doc.internalRemark = null;
    }

    if (['SPO', 'PFSPO', 'SPC', 'PFSPC'].includes(CompilationTypeData.get(+type).code)) {
      doc.vatGlobal = null;
      doc.accountManager = null;
      doc.exwConfirmed = null;
      doc.enRoute = null;
      doc.exwJapanDate = null;
      doc.transferTime1 = null;
      doc.arrivingVieDate = null;
      doc.vieDispatchDate = null;
      doc.transferTime2 = null;
      doc.etaCustomerDate = null;
      doc.customerRequestedDeliveryDate = null;
      doc.customerAcceptedDeliveryDate = null;
      doc.actualDeliveryDate = null;
      this.priceDate = null;
      if (this.selected.type === CompilationTypeData.get('OBIC').id) {
        this.dialogService.open(CommonDialogComponent, {
          context: {
            dialogType: NrkDialogType.obic, 
            compilation: this.selected,
          }
        }).onClose.subscribe(async x => {
          doc.lineItems[0].displayUnitQuantity = x.response.quantity;
          const dm = new DocMetrics(this.api, doc, doc.lineItems[0], new RoundPipe(), this.data);
          await dm.init();
          dm.save();
          x.businessId = mongoId(doc.recipient);
          x.price = InheritPriceOption.keep;
          x.vat = doc.lineItems[0].VATPercent;
          this.setInitialDocumentData(doc, x);
        })
      } else {
        doc.recipient = null;
        doc.recipientAddress = null;
        doc.recipientContact = null;
        doc.paymentPlan.recipientUID = null;
        doc.lineItems.forEach(el => {
          el.displayUnitPrice = null;
          el.piecePrice = null;
          el.VATPercent = null;
        })
        if (showSpoDialog) await this.spoDialog(doc, spoDialogRecipientId);
      }
      doc.invoicePercent = null;
      doc.lineItems.forEach(li => {
        li.discount = null;
      })
    }

    if (+type === CompilationTypeData.get('CN').id) {
      doc.lineItems.forEach(li => {
        li.quantity *= -1;
        li.displayUnitQuantity *= -1;
      })
      doc.deductibleItems.forEach(di => di.value *= -1);
      // doc.paymentPlan?.items?.forEach(ppi => ppi.invoices?.forEach(iv => iv.net *= -1));
      doc.deliveryRecipient = doc.deliveryContact = doc.deliveryAddress = null;
      doc.placeOfLoadingRecipient = doc.placeOfLoadingContact = doc.placeOfLoading = null;
      doc.manufacturerRecipient = doc.manufacturerServiceproviderAddress = null;
      doc.importerRecipient = doc.importerInfo = doc.importerAddress = null;
      doc.meansOfTransport = null;
    }

    if (+type === CompilationTypeData.get('OC').id && doc.lineItems.length) {
      doc.customerRequestedDeliveryDate = (doc.lineItems.map(m => m.dateOfDelivery) || [])
        .reduce((a, c) => !a || c < a ? c : a)
      doc.customerAcceptedDeliveryDate = doc.customerRequestedDeliveryDate;
      doc.showPackingPalletsInPdf = false;
      doc.useOldPackingConditions = false;
      doc.showPackingSummaryInPdf = true; // doc.packingConditions.length > 1; // true;
      if (this.selected.lineItems.some(li => li.finishedProduct?.content?.energy)) {
        doc.nextInvoiceDateRef = 'dateOfDispatch';
      }
    }

    if (['IN', 'PFIN'].includes(CompilationTypeData.get(+type).code)) {
      doc.dueDate = doc.nextPaymentDate = this.calcDueDate();
      doc.receptionHours = null;
      doc.deliveryContact = null;
      doc.manufacturerContact = null;
      doc.placeOfLoadingContact = null;
      doc.changelog = null;
      doc.showPackingPalletsInPdf = null;
      this.addressselectorComponents.forEach(el => el.reloadContacts());

      // // transfer test certificates to invoice
      // doc.testCertificate.files = this.tree.linkedPfspos?.reduce((a, c) => [...a, ...c?.testCertificates], [])
      // doc.testCertificate.completed = doc.testCertificate.files?.length > 0;
      
    }

    if (['DN'].includes(CompilationTypeData.get(+type).code)) {
      doc.showPackingPalletsInPdf = true;
      doc.receptionHours = this.contactUtil.getContactField(mongoId(this.selected.recipient), EContactFieldType.ReceptionHours, EContactType.Delivery);
      doc.showPackingPalletsInPdf = true;
      // doc.useOldPackingConditions = false;
      doc.showPackingSummaryInPdf = doc.packingConditions?.length > 1; // false;
    }

  }

  spoDialog(doc: CompilationModel, recipientId: string = null) {

    const separator = new BusinessModel();
    separator._id = nrkHrDummyId;

    let businesses = null;
    const b = this.data.business;
    switch (doc.type) {
      case CompilationTypeData.get('SPO').id:
        businesses = [b.nrvi, b.nrkv, b.micamation, b.bartech, b.ceva, separator, ...this.data.businesses];
        break;
      case CompilationTypeData.get('SPC').id:
        businesses = [b.ceva, b.dhl, separator, ...this.data.businesses];
        break;
      case CompilationTypeData.get('PFSPO').id:
        businesses = [b.nrkj, separator, ...this.data.businesses];
        break;
      case CompilationTypeData.get('PFSPC').id:
        businesses = [b.nrka, b.nrkg, b.nrkj, separator, ...this.data.businesses];
        break;
      default: businesses = this.data.businesses;
    }
    const businessOptions = businesses.map((b: BusinessModel) => ({ id: b._id, name: b.name }));

    return new Promise( res => {
      this.dialogService.open(CommonDialogComponent, {
        context: {
          dialogType: NrkDialogType.spoSelection,
          businessOptions: businessOptions,
          vatOptions: this.vatPercentOptions,
          responseText: recipientId,
          compilation: this.selected,
          showDeliveryConditions:
            !(doc.type === CompilationTypeData.get('PFSPO').id
              && this.selected.type === CompilationTypeData.get('OR').id
              && this.selected.sampleRequest
            ),
        },
      }).onClose.subscribe(async x => {
        if (x) {
          this.setInitialDocumentData(doc, x);
          this.setBusinesses();
          res(true);
        }
        res(false);
      })
    });
  }

  setLocked() {
    // this.locked = this.tree.isLoading || !this.selected.draft || this.selected.documentStatus != DocumentStatusData.get('draft').id;
    this.locked = !this.selected.draft || this.selected.documentStatus != DocumentStatusData.get('draft').id;
  }

  // ----------------------------------------------------- create documenmt entry point -------------------------------------------------------

  async doCreateDocument(type: number, fill: string | LineItemModel[], downstreamDoc = true, newVersion = false
    , attached = null, showSpoDialog = true) {

    this.prevDoc = this.selected;

    // check doc generation from NRKG -> NRKA TODO: fix this without hack
    // if (this.selected.issuer === 3 && this.issuer !== 3) this.issuer = 3;
    // console.log('issuer', this.selected.issuer);
    if (this.selected?.issuer) this.issuer = this.selected.issuer;

    let doc: CompilationModel;
    if (fill === 'empty') {
      doc = new CompilationModel();
      doc.issuer = this.issuer;
      doc.issuerAddress = this.selected.issuerAddress;
      doc.lineItems = [];
      doc.deductibleItems = [];
      doc.deliveryConditions = new DeliveryConditions();
      this.prevDoc = null;
      doc.packingStatus = null;
    } else {
      doc = Object.assign({}, this.selected);
      doc.issuer = this.issuer;
      doc.code = '';
    }
    // fill ... missing
    const newCloneEntry = new ChangelogEntry(doc, this.auth.user, `from ${getDocumentNumber(this.selected)}`);
    if (typeof fill !== 'string') { // lineitems from "remaining" split/selection (line-item-remaining component)
      doc.lineItems = fill;
      doc.issuer = this.issuer;
      doc.deductibleItems = [];
      doc.parent = this.selected.code;
    } else if (fill === 'all') { // clone document
      const lineItems = [];
      const deductibleItems = [];
      let lineItemsRef = this.selected.lineItems;
      if (this.tree.linkedOC && ['IN', 'PFIN'].includes(CompilationTypeData.get(type).code)) lineItemsRef = this.tree.linkedOC.lineItems;

      for (const li of lineItemsRef) {
        const newLi = Object.assign({}, li);
        if (attached !== null) {
          const finishedProduct = this.data.finishedProducts.find(f => mongoId(f) === mongoId(li.finishedProduct));
          newLi.productName = finishedProduct.calcCode + '; ' + finishedProduct.calcName;
          if (!newLi.position) newLi.position = new LineItemPosition();
          newLi.position.id = uniqid.time();
          newLi.pfspo = [];
          newLi.boxDetails = [];
          newLi.relatedOCs = [];
          // this.removeFromCombinedShipment();
          if (!this.tree.linkedObic && ['SPO', 'PFSPO'].includes(CompilationTypeData.get(this.selected.type).code)) {
            newLi.tbCode = null;
          }
        }
        // if (DocConfig.get('associatedPfspo').docs.indexOf(CompilationTypeData.get(type).code) < 0) {
        //   // delete newLi.pfspo;
        //   newLi.pfspo = undefined;
        // }
        lineItems.push(newLi);
      }
      doc.lineItems = lineItems;
      for (const di of this.selected.lineItems) {
        deductibleItems.push(Object.assign({}, di));
      }

    }

    doc._id = null;
    doc.type = type;
    doc.editCount = 1;
    if (!doc.paymentPlan) doc.paymentPlan = new PaymentPlan();
    if (!doc.shipmentLineItems) doc.shipmentLineItems = [];
    if (!doc.transportRun) doc.transportRun = new TransportRun();
    if (!doc.transactionReceipt) doc.transactionReceipt = new InvoiceUpload();
    if (!doc.proveOfDelivery) doc.proveOfDelivery = new InvoiceUpload();
    if (!doc.testCertificate) doc.testCertificate = new InvoiceUpload();
    if (!doc.offerData) doc.offerData = new OfferData();
    if (!doc.partialDelivery) doc.partialDelivery = { el: null, of: null };
    if (!doc.holidays) doc.holidays = [undefined, undefined];
    if (!doc.firstDate) doc.firstDate = new FirstDate();
    if (!doc.erpDate) doc.erpDate = new ErpDate();
    doc.firstDate.issueDate = new Date();

    doc.transportRun.transportStatus = TransportStatusData.get('planned').id
    doc.transportRun.spoStatus = SpoStatusData.get('unconfirmed').id
    doc.transportRun.availabilityStatus = AvailabilityStatusData.get('notCompleted').id
    doc.invoiceType = this.selected.invoiceType || 'delivery';
    doc.completelyInvoiced = null;
    doc.dueDate = null;
    doc.documentStatus = 1; // draft
    doc.issuedBy = mongoId(this.owner);
    doc.issueDate = new Date();
    if (!doc.currency) doc.currency = Currency.getDefault().code;
    doc.invoiceStatus = InvoiceStatusData.get('unpaid').id;
    const issuerBusinessId = this.getIssuerBusinessId(this.issuer);
    const issuerBusiness = this.data.businesses && this.data.businesses.find(f => mongoId(f) === mongoId(issuerBusinessId))
    // doc['maxArrivingVieDate'] = null
    doc.tmp = {} as any;

    // TODO: remove legacy PO PD (superseded by PO PD in line items)
    delete doc.customerPoPosition
    delete doc.partialDelivery

    console.log('delivery contact create 1', doc.deliveryContact);

    // TODO: resolve access legacy Users <=> UserModel & ContactModel
    // doc.accountManager = issuerBusiness && issuerBusiness.manager && issuerBusiness.manager['title'];
    if (newVersion || attached) {
      doc.code = this.selected.code;
      doc.parent = this.selected.parent;
      doc.deliveryConditions = this.selected.deliveryConditions || new DeliveryConditions();
      doc.packingConditions = [];
    } else {
      doc.parent = downstreamDoc ? this.selected.code : null;
      let spoDialogRecipient = null;
      if (this.selected.issuer === IssuerData.get('NRKG').id && doc.type === CompilationTypeData.get('SPO').id) {
        spoDialogRecipient = mongoId(this.data.businesses.find(f => /^NRKV$/.test(f.name)));
      } else if ( doc.type === CompilationTypeData.get('PFSPO').id) {
        spoDialogRecipient = mongoId(this.data.businesses.find(f => /^NRKJ$/.test(f.name)));
      }

      await this.setDataTransfer(type, doc, showSpoDialog, spoDialogRecipient);

    }

    this.selected = doc;
    this.onIssuerChanged(doc.issuer);
    // this.clipboardList = this.getClipboardList();

    if (+this.selected.type !== CompilationTypeData.get('OF').id) this.onIssuerContactChanged(mongoId(this.owner));
    if (+this.selected.type === CompilationTypeData.get('OR').id) {
      this.selected.meansOfTransport = 'Standard';
    }
    this.priceDate = new Date();
    this.dirtyString = safeStringify(this.selected);
    this.selected.draft = true;
    if (+this.selected.type === CompilationTypeData.get('IN').id) {
      this.selected.invoiceDownloaded = false;
      const contacts = this.selected.recipient && this.data.businesses.find(b => b._id === mongoId(this.selected.recipient)).contacts;
      const general = contacts?.filter(f => f.type === EContactType.General)
      const invoice = contacts?.filter(f => f.type === EContactType.Invoice)
      if (this.selected.differentInvoiceAddress || general?.length > 1 || invoice?.length > 0) {
        this.selected.recipientAddress = '';  
        if (this.recipientSelector) this.recipientSelector.addressOptionId = null;
        this.dialogService.open(CommonDialogComponent, {
          context: {
            message: 'Enter correct Invoice address',
          },
        });
      }
    } else if (+this.selected.type === CompilationTypeData.get('CN').id) {
      this.dialogService.open(CommonDialogComponent, {
        context: {
          header: 'Credit Note',
          message: 'Enter credit note reason',
          dialogType: NrkDialogType.input,
        },
      }).onClose.subscribe(data => this.selected.creditNoteReason = data && data.response);
    }
    if (+this.selected.type === CompilationTypeData.get('PFIN').id) {
      // this.selected.taxHint = 'Innergemeinschaftliche Lieferung, steuerfrei gemäss § 6a Abs. 1 UStG.';
      this.selected.invoiceStatus = 3; // fully paid
      if (!this.selected.paymentPlan) this.selected.paymentPlan = new PaymentPlan();
      this.selected.paymentPlan.termsOfPayment = 'NO COMMERCIAL VALUE - CUSTOMS PURPOSE ONLY';
    }
    if (+this.selected.type === CompilationTypeData.get('CN').id) this.selected.invoiceStatus = 3; // fully paid
    const nrkg = this.data.businesses.find(f => /^NRKG$/i.test(f.name));
    if (+this.selected.type === CompilationTypeData.get('OC').id && mongoId(this.selected.recipient) === mongoId(nrkg)) {
      this.selected.completelyInvoiced = true;
    }

    // if (['SPO'].includes(CompilationTypeData.get(doc.type).code) && mongoId(doc.deliveryRecipient) === mongoId(this.data.business.jerich) &&  mongoId(doc.recipient) === mongoId(this.data.business.nrkv)) {
    //   doc.deliveryConditions = new DeliveryConditions();
    //   doc.deliveryConditions.incoterms = 'DAP';
    //   doc.deliveryConditions.country = 'Austria';
    //   doc.deliveryConditions.place = '8200 Hofstätten an der Raab';
    // }
    if (doc.type === CompilationTypeData.get('SPO').id && mongoId(doc.recipient) === mongoId(this.data.business.nrkv)) {
      doc.deliveryConditions.incoterms = 'EXW';
      doc.deliveryConditions.country = 'Vietnam';
      doc.deliveryConditions.place = 'Ho Chi Minh City';
    }


    this.setLocked();

    if (newVersion) {
      this.selected.version = this.getMaxVersion(this.selected) + 1;
      (this.selected.changelog as ChangelogEntry[]).forEach(el => {
        el.files && el.files.forEach(f => f.checked = false);
      });
      this.dialogService.open(CommonDialogComponent, {
        context: {
          dialogType: NrkDialogType.revise,
          message: 'Enter a reason for revising the document:',
          okText: 'Revise document',
        },
      }).onClose.subscribe(async x => {
        if (x && x.button === NrkDialogButton.save && x.text.length) {
          this.reviseText = x.text;
        } else {
          this.cancelDraft(this.selected);
        }
      });

    } else {

      this.setVisibleFields();
      this.downstreamDocuments = [];
      this.selected.version = 1;
      this.selected.code = await this.getCalculatedCode(this.selected, true);

      // convert legacy document files
      this.convertLegacyDocumentFiles(); // TODO: remove in some distant future
      if (attached === null) {
        Object.keys(this.selected.documents).forEach(key => (this.selected.documents[key] || []).forEach((file: FileModel) => file.checked = false) );
      } else if (attached === false) {
        this.selected.files = [];
        this.selected.documents = [];
        this.selected.documentsInternal = [];
        this.selected.testCertificates = [];
        this.selected.transactionReceipt.files = [];
        this.selected.proveOfDelivery.files = [];
        this.selected.testCertificate.files = [];
        this.selected.packingConditions = [];
        this.tree.docNode.doc.transportRun.csDoc = null;
        this.tree.loadDocumentTree(this.selected);
      } else {
        console.log('attached tree', this.tree);
        if (this.tree.docNode) this.tree.docNode.doc.transportRun.csDoc = null;
        // this.tree.loadDocumentTree(this.selected);
      } 
      if (!this.selected.documents) this.selected.documents = [];
      if (!this.selected.documents[this.selected.type]) this.selected.documents[this.selected.type] = [];

      // console.log('this.selected', this.selected);
      // this.tree.loadDocumentTree(this.selected);
    }

    await this.tree.createDocumentNode(this.selected);
    if (this.lineItems) await this.lineItems.populateOrderLineItems(this.selected);


    this.addItem(this.selected);
    this.data.latestVersionItems.push(this.selected);
    this.setRelatedDocuments();
    if (!this.selected.changelog || downstreamDoc) {
      this.selected.changelog = [];
      this.loadChangelog(this.selected);
    }

    if (attached !== null) {
      newCloneEntry.type = ChangelogEntryType.clone;
      newCloneEntry.documentNumber = getDocumentNumber(this.selected);
      newCloneEntry.items = [{ quickText: 'INI', text: ''}];
      this.selected.changelog = [newCloneEntry];
      if (this.selected.pfspcCode) delete doc.pfspcCode;
    }

    this.copy = JSON.parse(safeStringify(this.selected));

    if (CompilationTypeData.get('TOF').id === this.selected.type) {
      this.selected.recipient = null;
      this.selected.recipientContact = null;
      this.selected.recipientAddress = null;
      this.selected.deliveryConditions = new DeliveryConditions();
      this.selected.paymentPlan = new PaymentPlan();
      this.setBusinesses();
    }

    console.log('delivery contact create 2', this.selected.deliveryContact);

    this.setNrkjOverrideNumber(this.selected);

    // super.toggleSidebar(this.selected);
  }

  createNewOffer(compilationType = CompilationTypeData.get('OF').id) {
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.newOffer,
        businessOptions: compilationType === CompilationTypeData.get('OF').id && this.data.businessOptions,
      },
    }).onClose.subscribe(async x => {
      if (x && x.button === NrkDialogButton.ok) {
        this.issuer = this.selected.issuer = +x.response.issuer;
        await this.onNewDocument(compilationType);
        this.setInitialDocumentData(this.selected, x.response);
        this.selected.manufacturerRecipient = mongoId(x.response.supplierId);
        this.selected.manufacturerServiceproviderAddress = this.contactUtil.getAddressFromBusiness(mongoId(x.response.supplierId))
        console.log('internal updates...')
        this.selected.projectRemark = new ProjectRemark();
        this.selected.projectRemark.projects = [];
        this.selected.internalUpdates = '';
        this.internalUpdates.open(this.selected);
      }
    });
  }

  createOfferFromTemplate() {
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.newOffer,
        businessOptions: this.data.businessOptions,
        deliveryConditions: SpoChoice.fromRecipinet,
        termsOfPayment: SpoChoice.fromRecipinet,
        offerFromTemplate: true,
      },
    }).onClose.subscribe(async x => {
      if (x && x.button === NrkDialogButton.ok) {
        // console.log('createOfferFromTemplate', x);
        this.issuer = this.selected.issuer = +x.response.issuer;
        await this.onNewDocument(CompilationTypeData.get('OF').id, false);
        this.setInitialDocumentData(this.selected, x.response);
        this.selected.manufacturerRecipient = x.response.supplierId;
        this.selected.manufacturerServiceproviderAddress = this.contactUtil.getAddressFromBusiness(x.response.supplierId);
        if (x.response.newProject.create) {
          this.showWizard = true;
          this.offerWizard.trialNumber = x.response.newProject.name;
          this.offerWizard.customer = x.response.businessId;
          this.offerWizard.supplier = x.response.supplierId;
          // console.log('create new project ', this.offerWizard);
        } else {
          this.selected.lineItems = [];
          this.selected.deductibleItems = [];
          this.selected.optionalLineItems = [];
        }
      }
    });
  }

  manageTemplates() {
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.manageTemplates,
        businesses: this.data.businesses,
      },
    }).onClose.subscribe(async x => {
      if (x && x.button === NrkDialogButton.ok) {
        this.setBusinesses();
      }
    });
  }

  fiscalNotDispatchDate(doc: CompilationModel) {

    const inFiscal = new Date(doc.vieDispatchDate) > new Date(doc.fiscalYear + '-10-01')
      && new Date(doc.vieDispatchDate) < new Date((+doc.fiscalYear+1) + '-09-30')

    return !inFiscal;

  }

  // ----------------------------------------------------- set current document entry point -------------------------------------------------------

  async setCurrentDocument(compilation: CompilationModel) {
    if (!compilation) return;

    // console.log(`document change: setCurrentDocument begin`, compilation.code) 

    if (this.tree.isLoading) {
      this.tree.stopLoading();
    }

    // this.selected = new CompilationModel();
    // Object.assign(this.selected, compilation);
    this.selected = compilation;
    
    // this.data.loadBusinesses().then(() => this.clipboardList = this.getClipboardList())
    // this.clipboardList = [await this.getMailSubject(false), this.getInMailSubject(false)];

    if (['PL','DN'].includes(CompilationTypeData.get(this.selected.type).code)) {
      // console.log('=====================================================================+ doc line')
      let doc = this.selected;
      do {
        doc = await this.api.loadCompilationByCode(doc.parent);
        // console.log('doc line items', doc?.code, doc?.lineItems, doc); 
        // console.log('doc parent', doc.parent, doc.code);
      } while (CompilationTypeData.get(doc.type).code !== 'OC')
      this.selected.lineItems = doc.lineItems;
      this.selected.packingConditions = doc.packingConditions;
      doc = await this.api.loadCompilationByCode(this.selected.code);
      doc.lineItems = this.selected.lineItems;
      this.api.saveCompilation(doc);
      // console.log('packing details', doc.code, this.selected.code, doc.packingConditions, this.selected.packingConditions);
    }

    // console.log('pre load document tree');

    this.tree.loadDocumentTree(compilation).then(() => {
      this.tree.injectPaymentPlanInvoicesNet(compilation);
      this.lineItems?.recalc();
    });

    this.downstreamDocuments = this.getDownstreamDocuments(compilation.code);
    if (!this.selected.tmp) this.selected.tmp = {} as any;
    if (!this.selected.editCount) this.selected.editCount = 1;
    if (!this.selected.paymentPlan) this.selected.paymentPlan = new PaymentPlan();
    if (!this.selected.shipmentLineItems) this.selected.shipmentLineItems = [];
    if (!this.selected.transportRun) this.selected.transportRun = new TransportRun();
    if (!this.selected.transactionReceipt) this.selected.transactionReceipt = new InvoiceUpload();
    if (!this.selected.proveOfDelivery) this.selected.proveOfDelivery = new InvoiceUpload();
    if (!this.selected.testCertificate) this.selected.testCertificate = new InvoiceUpload();
    if (!this.selected.offerData) this.selected.offerData = new OfferData();
    if (!this.selected.partialDelivery) this.selected.partialDelivery = { el: null, of: null };

    if (!this.selected.deductibleItems) this.selected.deductibleItems = [];
    if (!this.selected.deliveryConditions) this.selected.deliveryConditions = new DeliveryConditions();
    if (!this.selected.currency) this.selected.currency = Currency.getDefault().code;
    if (!this.selected.holidays) this.selected.holidays = [undefined, undefined];
    if (!this.selected.erpDate) this.selected.erpDate = new ErpDate();

    for (const key of Object.keys(this.selected.erpDate)) {
      // console.log('setCurrentDocument', key, this.selected.erpDate[key], this.selected.erpDate[key]);
      if (isErpDate(this.selected.erpDate[key]) && this.selected[key]) {
        this.selected.erpDate[key].val = new Date(this.selected[key]);
        // this.selected.erpDate[key].addToHistory(this.auth?.user?.short);
        this.data.addDateToHistory(this.selected.erpDate[key], '');
      }
    }

    if (this.selected.showPackingPalletsInPdf === undefined) this.selected.showPackingPalletsInPdf = true
    // if (this.selected.showPackingSummaryInPdf === undefined) this.selected.showPackingSummaryInPdf = true
    // if (
    //   this.selected.useOldPackingConditions === undefined 
    //   && (this.selected.packingConditions && !this.selected.packingConditions[0]?.items)
    // ) this.selected.useOldPackingConditions = true;

    this.setRelatedDocuments();
    this.selected.pfspoWithShipment = this.tree.linkedCS != null;
    this.selected.transportRun.relatedCS = getDocumentNumber(this.tree.linkedCS);

    this.priceDate = compilation.issueDate || new Date();
    if (!this.selected.invoiceStatus) this.selected.invoiceStatus = InvoiceStatusData.get('unpaid').id;

    // const business = this.data.businesses.find(f => mongoId(f) === mongoId(this.selected.recipient));
    // // this.api.loadBusiness(mongoId(business)).subscribe(_business => {
    //   const _business = this.data.businesses.find(f => mongoId(f) === mongoId(this.selected.recipient))
    //   this.data.loadUsers().then(users => {
    //     const user = users.find(u => mongoId(u.contact) === mongoId(_business?.manager))
    //     this.selected.accountManager = user?.name || '';
    //   })
    // // })

    // // this.selected['maxArrivingVieDate'] = null
    // this.data.loadUsers().then(u => {
    //   this.selected.accountManager = this.data.getBusinessManagerUser(this.selected.recipient)?.name || '';
    // })
    this.selected.accountManager = ((this.data.businesses.find(b => b._id === mongoId(this.selected.recipient))?.manager) as ContactModel)?.title || '';

    if (this.selected.showNetWeight === null || this.selected.showNetWeight === undefined) {
      this.selected.showNetWeight = true;
    }

    if (this.selected.draft) {
      this.reportDates?.syncDisplayDates();
    }

    // convert legacy document files
    this.convertLegacyDocumentFiles();

    this.reloadContacts();
    await this.onLineItemsChanged();

    this.setBusinesses();

    this.dirtyString = safeStringify(this.selected);
    this.setLocked();

    if (this.getNewDownstreamDoctype().find(f => f.code === 'OR-NRKA')) {
      const orders = await this.api.findAssociatedOrderForPfspc(this.selected.code);
      this.nrkaOrder = orders;
    }
    if (this.getNewDownstreamDoctype().find(f => f.code === 'OC-NRKG')) {
      const orders = await this.api.findAssociatedOc(this.selected.code);
      this.nrkgOc = orders;
    }
    this.statusCommentOptions = OfferStatusData.getOptions(this.selected.offerData?.offerStatus);

    this.visibleSections = DocConfig.getArray()
      .filter(f => f.value.index >= 0
        && (!(f.value as any).hideOnNonDocs
        || ((f.value as any).docs
          && (f.value as any).docs.indexOf(CompilationTypeData.get(this.selected.type).code) >= 0
        ))
      )

    this.loadChangelog(this.selected); // TODO: replace strings in database with ChangelogEntry[] & remove legacy code
    this.copy = JSON.parse(safeStringify(this.selected));
    this.lineItems && this.lineItems.syncPartialDelivery();

    // insert pfspo where missing (legacy)
    this.selected && this.selected.lineItems && this.selected.lineItems.forEach(li => {
      if (!li.pfspo) li.pfspo = [];
    })

    this.tcSpoMap = this.data.reloadTcSpoMap(this.selected);

    // TODO: !! replace all upstream/downstream etc stuff with DocumentTree

    // console.log(`document change: setCurrentDocument end`, compilation.code)

  }

  async setCurrentDocumentByRoute(code: string) {
    const issuer = code.match(/(nrk.)/i)[0].toLowerCase();
    this.router.navigate(['/pages/erp/document/' + issuer], { queryParams: { code: code }})
    // console.log('setCurrentDocumentByRoute', this.selected.notInInvoiceReport)

  }

  async setCurrentDocumentById(id: string) {
    const _compilation = await this.loadCompilation(id);
    this.setCurrentDocument(_compilation);
    // console.log('setCurrentDocumentById', this.selected.notInInvoiceReport)

  }

  async setCurrentDocumentByCode(code: string, version: number = null) {
    if (this.selected.code && !this.selected._id) this.dirtyString = ''; // unsaved doc (no _id) is always dirty
    this.canDismiss(this.selected).then(async res => {
      if (res && !this.selected._id) {
        this.removeItem(this.selected);
      }
      // const _compilation = await this.loadCompilationByCode(code, _version);
      const _compilation = await this.loadCompilationByCode(code, version);

      this.setCurrentDocument(res ? _compilation : this.selected);

      // console.log('setCurrentDocumentByCode', this.selected.notInInvoiceReport)

    });
  }

  // ----------------------------------------------------- download PDF preview -------------------------------------------------------

  async downloadPdf(newDoc: CompilationModel, merge: boolean = false,
    copy: boolean = false, zip: boolean = false, attachmentsOnly: boolean = false, replaceSelected = true) {

    // console.log('show doc preview hidden1');
    this.showDocumentPreviewHidden = true
    this.showDocumentPreview = true;
    // console.log('show doc preview hidden2');
    this.cdRef.detectChanges();
    // console.log('show doc preview hidden3');
    await waitForVariable(this, 'documentPrinter', 1000);
    // console.log('show doc preview hidden4');
    await new Promise(resolve => {
      // console.log('show doc preview hidden5');
      window.setTimeout(async () => {
        if (replaceSelected && newDoc) this.selected = newDoc;
        if (newDoc) this.documentPrinter.compilation = newDoc;
        this.cdRef.detectChanges();
        if (this.documentPrinter) this.documentPrinter.onDownloadPdf(merge, copy, zip, attachmentsOnly);
        resolve(true);
      }, 500);
      // console.log('show doc preview hidden7');
    })
    this.showDocumentPreview = false;
    // console.log('show doc preview hidden8');
    this.showDocumentPreviewHidden = false

  }


  convertLegacyDocumentFiles() {
    if (this.selected.documents && this.selected.documents.length && this.selected.documents[0] && this.selected.documents[0]['url']) {
      // url on [0] means legacy
      const newDocs = [];
      newDocs[0] = [];
      for (const doc of this.selected.documents) {
        newDocs[0].push(doc);
      }
      this.selected.documents = newDocs;
    } else if (!this.selected.documents || !this.selected.documents.length) {
      this.selected.documents = [];
      this.selected.documents[this.selected.type] = [];
    }
  }

  setDocChangelog(doc, prevDoc, text, type) {
    const entry: ChangelogEntry = new ChangelogEntry();
    entry.date = new Date();
    entry.user = this.auth.user;
    entry.documentNumber = (type === 'revised' ? getDocumentNumber(prevDoc) : getDocumentNumber(doc));
    entry.type = (type === 'revised' ? ChangelogEntryType.revised : ChangelogEntryType.cancelled);
    entry.change = (type === 'revised' ? 'Revise ' + getDocumentNumber(prevDoc) : 'Cancel ' + getDocumentNumber(doc));
    entry.items = [{ quickText: type, text: text }];
    entry.showInPdf = true;
    (doc.changelog as ChangelogEntry[]).splice(type === 'revised' ? 1 : 0, 0, entry);
    if (type === 'revised' && typeof prevDoc.changelog !== 'string') {
      const previousEntry = Object.assign({}, entry);
      previousEntry.documentNumber = getDocumentNumber(prevDoc);
      (prevDoc.changelog as ChangelogEntry[]).unshift(previousEntry);
    }
  }

  async setRevision(doc: CompilationModel, reviseText: string) {
    const selected = this.selected
    await new Promise(async resolve => {
      const prevVersionDoc = await this.api.loadCompilationByCode(doc.code, doc.version - 1);
      if (+prevVersionDoc.documentStatus !== DocumentStatusData.get('revised').id) {
        this.setCurrentDocument(prevVersionDoc);
        prevVersionDoc.cancelReason = reviseText;
        prevVersionDoc.documentStatus =  DocumentStatusData.get('revised').id;
        this.setDocChangelog(selected, prevVersionDoc, reviseText, 'revised');
        this.api.saveCompilation(selected);
        this.api.saveCompilation(prevVersionDoc);
        this.downloadPdf(prevVersionDoc).then(() => {
          this.setCurrentDocument(selected).then(() => {
            this.reloadItems();
            resolve(true);
          });
        });
      }
    });
  }

  // async synchronizeSharedFields() {
  //   const tree = this.getDocumentTree('OC');
  //   const type = CompilationTypeData.get(this.selected.type).code;

  //   // TODO: dirty check
  //   ['vieDispatchDate', 'packingConditions'].forEach(field => {
  //     const syncDocs = DocConfig.get(field).sync
  //     if (this.selected && syncDocs && syncDocs.includes(type)) {
  //       syncDocs.forEach(sf => {
  //         const doc = tree.filter(f => f.type === CompilationTypeData.get(sf).id);
  //         doc.forEach(async el => {
  //           const tmp = await this.api.loadCompilationByCode(el.code);
  //           tmp[field] = this.selected[field];
  //           this.api.saveCompilation(tmp);
  //         })
  //       })
  //     }
  //   });

  // }

  async setPackingStatus(status: EPackingStatus) {
    // const doc = await this.api.loadCompilationByCode(this.selected.code);
    // doc.packingStatus = this.selected.packingStatus = status;
    // await this.api.saveCompilation(doc);
    this.selected.packingStatus = status;
    //this.tree.synchronizeSharedFields(this.selected);
    await this.tree.synchronizeField(this.selected, 'packingStatus');
    const doc = await this.api.loadCompilationByCode(this.selected.code);
    this.selected.packingStatus = doc.packingStatus;
    console.log('setPackingStatus', this.selected.packingStatus, status);
  }

  packingStatusDisabled(status: EPackingStatus) {
    if ([EPackingStatus.delivered, EPackingStatus.completed].includes(status) && !this.tree.linkedIN?.proveOfDelivery?.completed) {
      return true;
    }
    if (status === EPackingStatus.completed && !this.tree.linkedIN?.transactionReceipt?.completed) {
      return true;
    }
    return null;
  }

  // ----------------------------------------------------- save document -------------------------------------------------------

  updateItem(item: CompilationModel, remove = false) {
    if (remove) {
      super.removeItem(item);
    } else {
      super.updateItem(item);
      (item as any).obics = (item.lineItems || []).map(i => i.tbCode).filter(f => f);
      item.recipient = this.data.businesses.find(f => mongoId(f) === mongoId(item.recipient))
    }
    this.data.latestVersionItems = this.getCurrentItems(this.items, true); //distinctFromObjectArray(this.items, 'code');
    this.setDisplayedItems();
    this.onSort(null);
  }

  async saveItem(item: CompilationModel, draft: boolean = false, silent = false): Promise<CompilationModel> {
    return new Promise(async (res, reject) => {

      if (!this.productsValid(item)) return;

      if (['IN', 'PFIN'].includes(CompilationTypeData.get(item.type).code)) {
        if (!await this.updateDueDate(item)) {
          res(item);
          this.locked = false;
          return;
        }
        if (item.testCertificates && item.testCertificates.length) {
          item.testCertificate.files = item.testCertificates;
          item.testCertificate.completed = true;
        }
        item.issueDate = new Date();
        this.data.fiscalYearUpdate(item);
      }

        this.event.emitPreSaveCompilation(item);

      // filter out null items
      this.selected.lineItems = this.selected.lineItems.filter(f => f);
      this.selected.deductibleItems = this.selected.deductibleItems.filter(f => f);
      // TODO: this.selected.documents[type][] => change numeric type do prop type ([OF,OR,OC,...])
      // this.selected.documents = (this.selected.documents as FileModel[]).filter(f => f && (f as any) !== []);
      // this.selected.shipmentLineItems = this.selected.shipmentLineItems.map(m => ({ code: m.document.code } as ShipmentLineItem));

      if (!item.code) item.code = item.code;
      const codeBackup = item.code;
      const statusBackup = item.documentStatus;
      try {

        if (!draft && item.documentStatus !== DocumentStatusData.get('final').id) {
          item.code = await this.getCalculatedCode(item, false);
          item.documentStatus =  DocumentStatusData.get('final').id;

          if (item.attachToOC && this.tree.linkedOC) {
            this.tree.linkedOC.lineItems.forEach((li, lidx) => {
              const spo = new AssociatedPfspo();
              spo.code = item.code;
              spo.parentPos = lidx+1;
              spo.pos = lidx+1;
              spo.quantity = li.displayUnitQuantity;
              spo.version = item.version;
              li.pfspo = [spo];
            })
            item.attachToOC = undefined;
            this.api.saveCompilation(this.tree.linkedOC);
          }
        } else if (draft) {
          item.documentStatus =  DocumentStatusData.get('draft').id; // todo remove redundancy
        }
        this.setRelatedDocuments();
        this.updateRelatedOCs();

        // TODO: linitem finished products are saved as objects, not as references!
        item.cancelReason = null;
        item.issuedBy = mongoId(this.owner);

        this.reportDates.save();
        this.data.setCSIdentifier(this.selected);

        // // fix issuer when changed NRKA <-> NRKG
        // if (/NRKG/.test(item.code) && this.issuer !== IssuerData.get('NRKG').id) this.issuer = IssuerData.get('NRKG').id;
        // if (/NRKA/.test(item.code) && this.issuer !== IssuerData.get('NRKA').id) this.issuer = IssuerData.get('NRKA').id;

        // autolog quantity changes in line items
        for (let i = 0; i < item.lineItems.length; i++) {
          const li = item.lineItems[i];
          const copyli = this.copy.lineItems?.find(f => f && f.position && li && li.position && f.position.id === li.position.id);
          if (copyli && li.quantity !== copyli.quantity) {
            await Changelog.addAutolog(item, this.auth.user, this.api, [{
              quickText: 'Change quantity',
              text: `Pos ${i+1} from ${copyli.quantity} pcs to ${li.quantity} pcs`,
            }]);
          }
        }

        // console.log('issue date after changelog', item.issueDate);

        // first (report) dates
        if (!item.firstDate) item.firstDate = new FirstDate(); // legacy
        ['issueDate', 'exwJapanDate'].forEach(el => {
          if (!item.draft && !item.firstDate[el] && item[el]) item.firstDate[el] = item[el];
        })

        // if ((item.type === CompilationTypeData.get('IN').id || item.type ===  CompilationTypeData.get('PFIN').id)
        //   && item.testCertificates && item.testCertificates.length) {

        //   item.testCertificate.files = item.testCertificates;
        //   item.testCertificate.completed = true;
        // }


        if (+item.type === CompilationTypeData.get('CN').id) {
          item.invoiceStatus = InvoiceStatusData.get('full').id;
        }

        this.setNrkjOverrideNumber(item);

        console.log('save item', item);
        // item.erpDate.updateHistory(this.auth?.user?.short);
        this.data.updateDateHistory(item, this.auth?.user?.short);
        await this.saveChangelog(item, silent, true);

        item = await this.api.saveCompilation(item);

        this.data.reloadPositionMap();

        if (this.pfsposChangelogOChelper.length) this.setPfspoChangelog(item);

        // TODO: merge api calls! -> reportDates
        if (+item.type === CompilationTypeData.get('CS').id) this.saveCombinedShipmentPSOs()
        this.toastrService.success(`Document '${item.code}' saved!`, 'Success');

        if (+item.type === CompilationTypeData.get('CN').id) {
          const tree = this.getDocumentTree('IN');
          tree.filter(f => f.type === CompilationTypeData.get('IN').id).forEach(async el => {
            const invoice = await this.api.loadCompilationByCode(el.code);
            invoice.invoiceStatus = InvoiceStatusData.get('full').id;
            console.log('save:', invoice.code, invoice.invoiceStatus);
            this.api.saveCompilation(invoice);
          })

        }

        // this.reloadItems();

        if (item.version > 1 && this.reviseText && this.reviseText.length) await this.setRevision(item, this.reviseText);

        const newItem = this.selected = await this.loadCompilationByCode(item.code, item.version);
        // this.clipboardList = [await this.getMailSubject(false), this.getInMailSubject(false)];

        // let idx = this.items.findIndex(item => item._id === newItem._id);
        // if (idx < 0) {
        //   this.items.unshift(Object.assign({}, newItem));
        //   idx = 0;
        // } else {
        //   this.items[idx] = Object.assign({}, newItem);
        // }
        this.updateItem(newItem);
        // (this.items[idx] as any).obics = (this.items[idx].lineItems || []).map(i => i.tbCode).filter(f => f);
        // this.items[idx].recipient = this.data.businesses.find(f => mongoId(f) === mongoId(this.items[idx].recipient))
        // this.data.latestVersionItems = distinctFromObjectArray(this.items, 'code');
        // this.setDisplayedItems();

        // this.data.latestVersionItems = this.data.latestVersionItems.filter(f => f.code !== newItem.code);
        // this.data.latestVersionItems.push(newItem);

        if (!draft && !silent) {
          this.dialogService.open(CommonDialogComponent, {
            context: {
              dialogType: NrkDialogType.pdfSelection,
              compilation: this.selected,
              user: this.auth.user,
            },
          }).onClose.subscribe(async x => {

            const dn = await this.api.loadCompilationByCode(newItem.parent);
            // this.dialogService.open(CommonDialogComponent, {
            //   context: {
            //     dialogType: NrkDialogType.mailTemplate,
            //     mailInfo: {
            //       in: newItem,
            //       dn: dn,
            //       invoiceSendTo: this.invoiceSendTo,
            //       deliveryNoteSendTo: this.deliveryNoteSendTo,
            //       testCertificateSendTo: this.testCertificateSendTo,
            //     },
            //     user: this.auth.user,
            //   }
            // })

            // console.log('download PDF...');
            if (x?.tc && newItem.testCertificate?.files?.length) {
              // console.log('download test certificate', newItem.testCertificate)
              await this.api.downloadFile(newItem.testCertificate?.files[0]);
            }
            if (x?.dn) {
              // console.log('download DN', newItem.parent, dn.code);
              if (dn) await this.downloadPdf(dn);
            }
            window.setTimeout(async () => {
              if (x) switch(x.downloadType) {
                case DownloadType.document: this.downloadPdf(newItem); break;
                case DownloadType.merged: this.downloadPdf(newItem, true); break;
                case DownloadType.zipMerged: this.downloadPdf(newItem, true, false, true); break;
                case DownloadType.zipAttachments: this.downloadPdf(newItem, true, false, true, true); break;
                case DownloadType.pdfAndZip:
                  await this.downloadPdf(newItem);
                  this.downloadPdf(newItem, true, false, true, true); break;
              }
            }, x?.dn ? 2000 : 0);
          });

          if (['IN'].includes(CompilationTypeData.get(this.selected.type).code) && this.tree.linkedOC?.paymentPlan?.items?.length) {
            this.dialogService.open(CommonDialogComponent, {
              context: {
                dialogType: NrkDialogType.connectToPaymentPlan,
                compilation: this.selected,
              },
            }).onClose.subscribe(async x => {
              // console.log('save invoice response', x, this.lineItems.getTotalNet(false), this.lineItems.netTotal);
              if (x.button === 3) return; // cancel
              const refDoc = this.tree.invoiceDocs?.find(f => f.code === this.selected.code);
              const inv = new PaymentPlanInvoice();
              inv.code = this.selected.code;
              inv.issueDate = this.selected.issueDate;
              inv.net = /^CNNRK/.test(inv.code) ? Math.abs(refDoc.sumTotal) : -Math.abs(refDoc.sumTotal); // getTotalNet(this.selected, false, false) : -getTotalNet(this.selected, false, false);
              inv.paymentStatus = this.selected.invoiceStatus;
              inv.paymentType = this.selected.invoicePayment;
              x.oc.paymentPlan.items[x.index].invoices.push(inv);
              x.oc.paymentPlan.items[x.index].invoice = this.selected.code;
              await this.api.saveCompilation(x.oc);
              if (x.downloadOC) {
                await this.downloadPdf(x.oc, false, false, false, false, false);
              }
            });
          }
        }

        this.dirtyString = safeStringify(newItem);
        // this.synchronizeSharedFields();
        this.tree.synchronizeSharedFields(this.selected).then(() => {
            this.tree.loadDocumentTree(this.selected).then(() => this.lineItems && this.lineItems.syncPartialDelivery()) // TODO: include compilation
            this.event.emitPostSaveCompilation(newItem);
        })


        res(newItem);

      } catch (err) {

        console.error(err);

        let msg = err.error?.errmsg || err.error?.message || ('err.status: ' + err.status);

        if (err.error && err.error.code === 11000 && err.error.keyValue.code) {
          msg = `Document ${err.error.keyValue.code} version ${err.error.keyValue.version} already exists`;
          item.code = codeBackup;
          item.documentStatus = statusBackup
          item.version += 1;
        } else if (err.status == 423) {
          msg = `Document ${getDocumentNumber(this.selected)} already exists`;
        }

        this.toastrService.danger(msg, 'Error');

        reject(item);
      }
    });
  }

  // async processChecklist() {
  //   return;
  //   const type = CompilationTypeData.get(this.selected.type).code;
  //   const checklist = new ChecklistUtil(this.api, this.toast);
  //   const items = await checklist.get(type);
  //   if (!items) return;
  //   const checklistItems = items.data.map(m => ({text: m, checked: false }));
  //   if (checklistItems) return new Promise(resolve => {
  //     this.dialogService.open(CommonDialogComponent, {
  //       closeOnBackdropClick: false,
  //       context: {
  //         dialogType: NrkDialogType.checklist,
  //         checklistItems: checklistItems,
  //       },
  //     }).onClose.subscribe(() => {
  //       resolve(true);
  //     });
  //   });
  // }

  productsValid(item: CompilationModel) {

    if (['OC', 'PL', 'DN' , 'IN', 'PFIN', 'CN'].includes(CompilationTypeData.get(this.selected.type).code)) {

      const mismatches = [];
      item.lineItems.forEach((el, idx) => {
        el.pfspo.forEach(spoli => {
          // console.log('compare', el.finishedProduct?.calcCode, spoli.docLineItem?.finishedProduct?.calcCode);
          if (spoli.docLineItem?.finishedProduct && el.finishedProduct?.calcCode !== spoli.docLineItem?.finishedProduct?.calcCode) {
            mismatches.push(`Pos ${idx+1}: ${el.finishedProduct?.calcCode} ≠ ${spoli.code}: ${spoli.docLineItem?.finishedProduct?.calcCode}`)
          }
        })
      })
      const confirmed = mismatches.length ? window.confirm(`Product mismatch ${item.code}:\n\n${mismatches.join('\n')}\n\nAre you sure to continue?`) : true;
      return confirmed;
    }

    return true;
  }

  calcDueDate() {


    // const reportField = this.data.compilationData
    const paymentTextTable = this.data.compilationData.paymentStore?.find(f => f.id === 'paymentText');
    const paymentTextRow = paymentTextTable?.data?.find(f => f.text === this.selected.paymentPlan?.text);

    const termsOfPaymentTable = this.data.compilationData.paymentStore?.find(f => f.id === 'termsOfPayment');
    const termsOfPaymentRow = termsOfPaymentTable?.data?.find(f => f.text === this.selected.paymentPlan?.termsOfPayment);

    const date = this.selected[paymentTextRow?.reportField] || this.selected.issueDate;
    const days = termsOfPaymentRow?.days || 0;
    const eom = termsOfPaymentRow?.eom || false;
    const plusDays = termsOfPaymentRow?.plusDays || 0;

    let calcDate = moment(date).add(days, 'days');
    if (eom) calcDate.endOf('month');
    if (plusDays) calcDate.add(plusDays, 'days');

    // console.log('calc due date: ', date, ' + ', days, ' eom: ', eom, ' + ', plusDays, ' = ', calcDate.toDate(), ' pd: ', paymentTextRow?.reportField, ' issue: ', this.selected.issueDate);

    return calcDate.toDate();
  }

  async updateDueDate(doc: CompilationModel = this.selected): Promise<boolean> {
    if (doc.paymentPlan?.termsOfPayment === 'NO COMMERCIAL VALUE - CUSTOMS PURPOSE ONLY') return true; // TODO: generalize
    return new Promise(resolve => {
      const dueDate = this.calcDueDate();

      if (moment(dueDate).diff(moment(doc.dueDate), 'days') !== 0 || moment(doc.dueDate).isBefore(moment())) {
        this.dialogService.open(CommonDialogComponent, {
          closeOnBackdropClick: true,
          context: {
            dialogType: NrkDialogType.dueDateCalculation,
            compilation: doc,
            dueDate: dueDate,
          },
        }).onClose.subscribe(async x => {
          if (x?.button === NrkDialogButton.cancel) {
            resolve(false);
            return;
          }
          doc.nextPaymentDate = doc.dueDate;
          resolve(true);
        });
      } else {
        resolve(true);
        return
      }
    });
  }

  async setPfspoChangelog(item: AbstractItemType) {
    const pfspos = this.pfsposChangelogOChelper;
    for (const pfspo of pfspos) {
      const spo = await this.api.loadCompilationByCode(pfspo.code);
      if (pfspo.assigned) await Changelog.addAutolog(spo, this.auth.user, this.api, [
        { quickText: 'Assigned to OC', text: getDocumentNumber(item)},
      ])
      if (pfspo.removed) await Changelog.addAutolog(spo, this.auth.user, this.api, [
        { quickText: 'Removed from OC', text: getDocumentNumber(item)},
      ])
      this.api.saveCompilation(spo);
    }
    this.pfsposChangelogOChelper = [];
  }

  async updateRelatedOCs() {
    console.log('updateRelatedOCs', this.selected.lineItems.map(li => li.relatedOCs).flat());
    // set related order confirmations' dispatch date to confirmed to confirmed if spo status is confirmed
    if (!['SPO', 'PFSPO'].includes(CompilationTypeData.get(this.selected.type).code)) return
    // const ocs = await this.api.getRelatedOcs(this.selected.code);
    const ocs =  this.selected.lineItems.map(li => li.relatedOCs).flat().filter(nn => nn);

    for (const comp of ocs) {
      const oc = await this.api.loadCompilationByCode(comp.doc.code);
      if (this.selected.transportRun.spoStatus !== 0) oc.dispatchDateUnconfirmed = false;
      oc.internalExwDate = this.selected.internalExwDate;
      oc.endOfWarranty = this.selected.endOfWarranty;
      oc.dateOfDrawings = this.selected.dateOfDrawings;
      oc.dateOfSourcing = this.selected.dateOfDrawings;
      this.api.saveCompilation(oc);
      console.log('updateRelatedOCs', oc.code, oc.internalExwDate);
    }
    // console.log('related ocs', this.selected.lineItems.map(li => li.relatedOCs));
  }

  async cancelDocument(item: CompilationModel, relatedDocuments = this.relatedDocuments) {
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: ['SPO', 'PFSPO'].includes(CompilationTypeData.get(+item.type).code) ? NrkDialogType.okCancel : NrkDialogType.okCancelResponse,
        compilation: item,
        relatedDocuments: relatedDocuments,
        removedSpos: 
          item.type === CompilationTypeData.get('OC').id 
          && Array.from(new Set(relatedDocuments.map(m => m.doc.lineItems.map(li => li.pfspo.map(spo => spo.code)).flat()).flat())),
        message: ['SPO', 'PFSPO'].includes(CompilationTypeData.get(+item.type).code) ? '' : 'Enter a reason for cancelling the document(s):',
        okText: 'Cancel document(s)',
        cancelText: 'Abort',
      },
    }).onClose.subscribe(async x => {

      console.log('cancel', x, x.button === NrkDialogButton.save, x.text?.length, ['SPO', 'PFSPO'].includes(CompilationTypeData.get(+item.type).code))

      if (x && x.button === NrkDialogButton.save && (x.text?.length || ['SPO', 'PFSPO'].includes(CompilationTypeData.get(+item.type).code))) {

        for (const doc of x.cancelDocs) {
          this.setDocChangelog(doc, null, x.text, 'cancelled');
          await this.api.cancelCompilation(doc.code, x.text || null, doc.changelog[0]);
        }
        this.selected = await this.loadCompilationByCode(item.code || this.selected.code);
        // this.clipboardList = [await this.getMailSubject(false), this.getInMailSubject(false)];
        this.setRelatedDocuments();
        this.reloadItems();
        if (item) this.downloadPdf(null);

      }
    });
  }

  cancelOrderConfirmations() {
    const ocDocs = this.tree.filterDocumentTree('OC', this.tree.docNode) || [];
    const ocs = [];
    for (const oc of ocDocs) {
      ocs.push(...this.tree.getDisplayTree(this.tree.findNode(oc.code)))
    }
    this.cancelDocument(null, ocs);
  }

  hideSidebar() {
    if (this.isOffersPage()) {
      this.issuer = null;
    }
    super.hideSidebar();
  }

  async cancel(item: CompilationModel, force: boolean = false) {
    // console.log('dismaiss', this.canDismiss)
    if (force || await this.canDismiss(item)) {
      this.hideSidebar();
    }
  }

  async undoEdit(item: CompilationModel) {
    this.lock(true);
  }

  async cancelDraft(item: CompilationModel) {
    if (item._id && item.draft) {
      try {
        await this.api.deleteCompilation(item);
        this.updateItem(item, true);
        this.downstreamDocuments = this.getDownstreamDocuments(item.code);
      } catch (e) {
        console.error(e);
      }
    }
    const doc = this.getVersions(item).reverse()[0];
    // console.log('====>doc', doc, item.version, item.parent);
    // if (!doc) {
    //   if (item.version === 1 && item.parent) {
    //     console.log('====>doc', doc, item.version, item.parent);
    //     this.setCurrentDocumentByCode(item.parent);
    //   } else {
    //     this.cancel(item, true);
    //   }
    // } else {
    //   this.switchToVersion(doc);
    // }
    if (!doc || (item.version === 1 && item.parent)) {
      // console.log('====>doc', doc, item.version, item.parent);
      this.setCurrentDocumentByCode(item.parent);
    } else {
      this.switchToVersion(doc);
    }
  }

  async validate(): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let valid = true;
      this.selected.lineItems && this.selected.lineItems.forEach((item, idx) => {
        if (item.finishedProduct == null) {
          this.toastrService.danger('Product selection missing for line item #' + (idx+1), 'Validation Error');
          valid = false;
        }
        if (this.selected.type === CompilationTypeData.get('OC').id && !(item.position.orderPos >= 0 || item.position.orderPos === -2)) {
          this.toastrService.danger('No order position assigned to line item #' + (idx+1), 'Validation Error');
          valid = false;
        }
      })
      if (this.selected.vatGlobal == null && this.data.visibleMap.vat) {
        this.toastrService.danger('Global VAT must be defined', 'Validation Error');
        valid = false;
      }

      if (DocConfig.isMandatory('vieDispatchDate', this.selected.type)) {
        if (!this.selected.vieDispatchDate) {
          this.toastrService.danger(DocConfig.get('vieDispatchDate').label
            + ' must be defined', 'Validation Error');
          valid = false;
        }
      }
      if (DocConfig.isMandatory('customerRequestedDeliveryDate', this.selected.type)) {
        if (!this.selected.customerRequestedDeliveryDate) {
          this.toastrService.danger(DocConfig.get('customerRequestedDeliveryDate').label
            + ' must be defined', 'Validation Error');
          valid = false;
        }
      }
      if (DocConfig.isMandatory('customerAcceptedDeliveryDate', this.selected.type)) {
        if (!this.selected.customerAcceptedDeliveryDate) {
          this.toastrService.danger(DocConfig.get('customerAcceptedDeliveryDate').label
            + ' must be defined', 'Validation Error');
          valid = false;
        }
      }
      if (DocConfig.isMandatory('offerValidity', this.selected.type)) {
        if (!this.selected.offerValidity) {
          this.toastrService.danger(DocConfig.get('offerValidity').label
            + ' must be defined', 'Validation Error');
          valid = false;
        }
      }
      if (DocConfig.isMandatory('etaCustomerDate', this.selected.type)) {
        if (!this.selected.etaCustomerDate) {
          this.toastrService.danger(DocConfig.get('etaCustomerDate').label
            + ' must be defined', 'Validation Error');
          valid = false;
        }
      }
      if (DocConfig.isMandatory('recipientAddress', this.selected.type)) {
        if (!/\w+/.test(this.selected?.recipientAddress)) {
          this.toastrService.danger('Recipient address must be defined', 'Validation Error');
          valid = false;
        }
      }
      // if (this.selected.type === CompilationTypeData.get('DN').id) {
      //   if (this.selected.visibleFields?.includes('packingConditions') && !this.selected.packingConditions?.length && !this.selected.packingText) {
      //     this.toastrService.danger('Packing details have to be defined', 'Validation Error');
      //     valid = false;
      //   }
      // }
      const maxSPOArrivingDate = moment.max(this.tree?.linkedPfspos?.map(spo => moment(spo?.arrivingVieDate)));
      const isIndirectDelivery = this.tree?.linkedPfspos?.find(spo => spo?.directDelivery !== true);
      if (
        moment(new Date(this.selected.vieDispatchDate)).diff(maxSPOArrivingDate, 'days') < 0
        && CompilationTypeData.get(this.selected.type).code === 'OC'
        && isIndirectDelivery
      ) {
        this.toastrService.danger('Dispatch cannot be earlier than arrival date', 'Validation Error');
        valid = false;
      }
      // if (moment(new Date(this.selected.vieDispatchDate)).diff(maxSPOArrivingDate, 'days') < 0
      //     && CompilationTypeData.get(this.selected.type).code === 'OC'
      //     && !(this.tree.linkedPfspos && this.tree.linkedPfspos.length && this.tree.linkedPfspos[0].directDelivery)) {
      //   this.toastrService.danger('Dispatch must not be erlier than arrival date', 'Validation Error');
      //   valid = false;
      // }

      // if (this.selected.dueDate == null && this.data.visibleMap.dueDate
      //     && !/no commercial value/i.test(this.selected.paymentPlan.termsOfPayment)
      //     && +this.selected.type !== CompilationTypeData.get('PFIN').id
      // ) {
      //   this.toastrService.danger('Due date must be defined', 'Validation Error');
      //   valid = false;
      // }
      // console.log('===>validate',['IN'].includes(CompilationTypeData.get(this.selected.type).code), )
      if (['IN'].includes(CompilationTypeData.get(this.selected.type).code)) {
        if (!this.selected.paymentPlan.recipientUID?.length) {
          this.toastrService.danger('Recipient UID/ CRN is required',
            'Validation Error');
          valid = false;
        }
        const displayDates = DocConfig.getArray().filter(f => f.value.type === 'displayDate').map(m => m.value.checked);
        if (!displayDates.includes(true)) {
          this.toastrService.danger('No display date selected',
            'Validation Error');
          valid = false;
        }
        if (!this.selected.paymentPlan?.termsOfPayment || !this.data.termsOfPaymentOptions.find(f => f.id === this.selected.paymentPlan.termsOfPayment)) {
          this.toastrService.danger('Terms of payment right text is not defined in payment editor utility',
            'Validation Error');
          valid = false;
        }
        if (!this.selected.paymentPlan?.text|| !this.data.paymentTextOptions.find(f => f.id === this.selected.paymentPlan.text)) {
          this.toastrService.danger('Terms of payment left text is not defined in payment editor utility',
            'Validation Error');
          valid = false;
        }
      }
      if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.selected.type).code)
          && new Date(this.selected.exwJapanDate) > new Date() && this.selected.transportRun.transportStatus > 1) {
        this.toastrService.danger('EXW date can\'t be in the future if the transport status is "en route" or "completed"',
          'Validation Error');
        valid = false;
      }
      if (this.selected.pfspoWithShipment && this.data.visibleMap.pfspoWithShipment && !this.tree.linkedCS) {
        this.toastrService.danger('Grouped shipment is missing', 'Validation Error');
        valid = false;
      }

      // ---- TODO: unify if bug is fixed
      if (this.tree.parentNode?.doc.issuer === 3 && this.selected.issuer === 2) {
        this.toastrService.danger(`Something went wrong \nwon\'t generate NRKA doc (${this.selected.code}) from NRKG (${this.tree.parentNode?.doc.code})`, 'Validation Error');
        this.api.debugLog('verification error ${this.selected.code}', {
          msg: 'Something went wrong \nwon\'t generate NRKA doc from NRKG',
          parent: this.tree.parentNode?.doc.code,
          parentIssuer: this.tree.parentNode?.doc.issuer,
          doc: this.selected.code,
          docIssuer: this.selected.issuer,
        });
        valid = false;
      }
      if (this.issuer !== this.selected.issuer && !this.selected.nrkjOverride) {
        this.toastrService.danger(`Issuer mismatch:\nDocument: ${IssuerData.get(this.selected.issuer).name}\nPage: ${IssuerData.get(this.issuer).name}}`, 'Validation Error');
        valid = false;
      }
      if (!this.selected.nrkjOverride && this.selected.parent && !this.selected.code.replace(/.*(NRK.).*/, '$1').includes(this.selected.parent.replace(/.*(NRK.).*/, '$1'))) {
        this.toastrService.danger(`Issuer mismatch:\nDocument: ${this.selected.code}\nParent: ${this.selected.parent}`, 'Validation Error');
        valid = false;
      }

      if (valid && this.selected.useOldPackingConditions && this.selected.packingConditions.length) {
        valid = await new Promise((res, rej) => {
          this.dialogService.open(CommonDialogComponent, {
            context: {
              dialogType: NrkDialogType.okCancel,
              message: 'Use legacy packing details is selected although there are pallets defined.\nDo you still want to save?',
              okText: 'Yes',
              cancelText: 'No',
            },
          }).onClose.subscribe(async x => {
            if (x.button !== NrkDialogButton.save) {
              res(false);
            }
            res(valid);
          });
        })
      }

      let mismatch = null;
      this.selected?.lineItems?.find((li, lidx) => {
        const posPacking = this.selected.packingConditions.filter(f => f.lineItemIdx === lidx).flatMap(m => m.items)
        const posQ = posPacking.reduce((a, c) => a += c.quantity, 0);
        if (!this.selected.useOldPackingConditions && li.finishedProduct.type === EProductType.Energy && li.quantity - posQ) mismatch = { lineItem: li, pos: lidx, packingQ: posQ }
      })

      if (valid && mismatch && ['DN', 'IN'].includes(CompilationTypeData.get(this.selected.type).code)) {
        valid = await new Promise((res, rej) => {
          this.dialogService.open(CommonDialogComponent, {
            context: {
              dialogType: NrkDialogType.okCancel,
              message: `Different Q on line item and Packing details!
                        \nPosition: ${mismatch.pos + 1}
                        \nLine Item Q: ${mismatch.lineItem.quantity}
                        \nPacking Q: ${mismatch.packingQ}
                        \nDo you still want to save?`,
              okText: 'Yes',
              cancelText: 'No',
            },
          }).onClose.subscribe(async x => {
            if (x.button !== NrkDialogButton.save) {
              res(false);
            }
            res(valid);
          });
        })
      }

      resolve(valid);
    })
  }

  saveCombinedShipmentPSOs() {
    this.selected.shipmentLineItems.forEach(async li => {
      const pso = await this.loadCompilationByCode(li.code);
      if (!pso.transportRun) pso.transportRun = new TransportRun();
      pso.transportRun.transportStatus = (this.selected.transportRun || {})['transportStatus'];
      pso.exwDate = pso.exwJapanDate = this.selected.exwJapanDate;
      pso.dateOfVieArrival = pso.arrivingVieDate = this.selected.arrivingVieDate;
      pso.meansOfTransport = this.selected.meansOfTransport;
      // pso.lineItems = li.document.lineItems;
      pso.lineItems.forEach((spoli, idx) => {
        const lli = li.document?.lineItems[idx];
        if (lli?.factoryOrderNumber) spoli.factoryOrderNumber = lli.factoryOrderNumber;
        if (lli?.numberOfTC) spoli.numberOfTC = lli.numberOfTC;
        if (lli?.dateOfTC) spoli.dateOfTC = lli.dateOfTC;
        if (lli?.dateOfProduction) spoli.dateOfProduction = lli.dateOfProduction;

      })
      this.api.saveCompilation(pso);
    })
  }

  canModify(cancel: boolean = false, canCancel = false) {
    if (canCancel) return true;
    return (cancel || this.getMaxVersion(this.selected) === this.selected.version)
      && +this.selected.type !== CompilationTypeData.get('IN').id
      && +this.selected.type !== CompilationTypeData.get('CN').id
      && +this.selected.type !== CompilationTypeData.get('PFIN').id
      && +this.selected.type !== CompilationTypeData.get('PFCN').id;
  }

  canEdit() {
    return this.selected.version === this.getMaxVersion(this.selected);
  }

  isDirty(): boolean {
    return false; // TODO: tidy dirty check;
    try {
      const dirty = this.dirtyString != JSON.stringify(this.selected);
      return dirty;
    } catch (e) {
      console.error(e);
      return false; 
    }
  }

  previousDocumentOfThisDoctype() {
    const docs = Array.from(new Set(this.data.compilationItems.filter(f => f.type === this.selected.type && f.issuer === this.selected.issuer).map(m => m.code))).sort();
    const idx = docs.indexOf(this.selected.code);
    const prev = idx > 0 ? docs[idx-1] : docs[0];
    this.setCurrentDocumentByCode(prev);
  }

  nextDocumentOfThisDoctype() {
    const docs = Array.from(new Set(this.data.compilationItems.filter(f => f.type === this.selected.type && f.issuer === this.selected.issuer).map(m => m.code))).sort();
    const idx = docs.indexOf(this.selected.code);
    const next = idx < docs.length-1 ? docs[idx+1] : docs[docs.length-1];
    this.setCurrentDocumentByCode(next);
  }

  addressChanged(event) {
    console.log('event', event, this.selected.importerAddress);
  }

  // =========================================================================================================

  // showInvoiceUpload() {
  //   return (this.selected && !this.selected.draft
  //     && (this.selected.type === CompilationTypeData.get('IN').id
  //     || this.selected.type === CompilationTypeData.get('PFIN').id
  //     || this.selected.type === CompilationTypeData.get('CS').id))
  // }

  getDocumentStatus() {
    return (this.selected && this.selected.documentStatus && DocumentStatusData.get(this.selected.documentStatus).name) || '';
  }

  getDownstreamDocuments(code: string, latest = true): CompilationModel[] {
    return latest ? this.data.latestVersionItems.filter(f => f.parent === code) : this.items.filter(f => f.parent === code);
  }

  // TODO: replace document tree with tree-service
  async recurseDownstreamDocuments(model: CompilationModel, level: number, draft: boolean, withCancelled = false): Promise<{doc: CompilationModel, text: string}[]> {

    level++;
    const ret: {doc: CompilationModel, text: string}[] = [];
    const space = Array(level).join('-');

    for (const el of this.getDownstreamDocuments(model.code, true)) {
      if ((withCancelled || +el.documentStatus !== DocumentStatusData.get('cancelled').id) && el._id && !el.draft) {
        const doc = await this.api.loadCompilationByCode(el.code);
        const date = doc.issueDate ? ' (' + this.datePipe.transform(doc.issueDate, 'yyyy-MM-dd') + ')' : '';
        ret.push({
          doc: doc,
          text: space + ' ' + getDocumentNumber(el) + date,
        },
        ...await this.recurseDownstreamDocuments(el, level, draft, withCancelled)
        );
      }
    };

    return ret;
  }

  // TODO: replace document tree with tree-service
  // getDocumentTree(topDoc = 'OR'): CompilationModel[] {
  //   let top = this.selected;
  //   while (top.parent && top.type !== CompilationTypeData.get(topDoc).id) {
  //     top = this.data.latestVersionItems.find(f => f.code === top.parent);
  //   }
  //   const tree = [];
  //   const recurse = (start: CompilationModel) => {
  //     tree.push(start);
  //     const dd = this.getDownstreamDocuments(start.code);
  //     for (const doc of dd) recurse(doc);
  //   }
  //   recurse(top);
  //   return tree;
  // }

  getDocumentTree(topDoc = 'OR'): CompilationModel[] {
     return this.tree.getFlatByDocType(topDoc, this.selected);
  }

  async setRelatedDocuments() {
    this.relatedDocuments = [];
    let top = this.selected;
    let overflow = 10;

    do {
      this.relatedDocuments.unshift({
        doc: top,
        text: getDocumentNumber(top)
          + (top.issueDate ? ' (' + this.datePipe.transform(top.issueDate, 'yyyy-MM-dd') + ')' : ''),
      });
      top = (top.parent && await this.api.loadCompilationByCode(top.parent));
    } while (top && overflow--);

    if (overflow < 1) {
      console.error('overflow while setting related documents!');
      if (top) console.error('[' + top.code + ', ' + top.parent + ']');
    }

    const docs = await this.recurseDownstreamDocuments(this.selected, 1, false, true);
    this.relatedDocuments.push(...docs);
    this.selected.relatedDocuments = this.relatedDocuments.map(m => m.text).join('\n');

    // TODO: this does belog to a separate funtion for new document / current document initialization
    if (['PFSPO'].includes(CompilationTypeData.get(+this.selected.type).code) && !this.selected.pfspoInDisclaimer) {
      this.selected.pfspoInDisclaimer = this.data.compilationData.staticTexts.find(f => f.id === 'pfspoInDisclaimer')?.data[0];
    }
    if (!this.selected.packingStatus) this.selected.packingStatus = EPackingStatus.notReadyForPacking;

    const b = this.getIssuerBusinessId(this.selected.issuer);
    const issuer = this.data.businesses.find(f => f._id === mongoId(b))?.contacts.find(f => f.type === EContactType.General);
    if (!this.selected.documentFooter) this.selected.documentFooter = new DocumentFooter();
    this.selected.documentFooter.address = this.getAddress(issuer);
    this.selected.documentFooter.registry = this.getRegistry(issuer);
    this.selected.documentFooter.bank = this.getBank(issuer);

    console.log('document footer', this.selected.documentFooter);


    // (click)="getMailSubject()" [title]="'Copy ('+ getMailSubject(false) + ') to clipboard'"

    // this.clipboardList = [await this.getMailSubject(false), this.getInMailSubject(false)];
  }

  onClipboardList(item: string) {
    this.copyToClipboard(item);
    // this.clipboardBtn?.hide();
    this.hidePopovers();
  }

  hidePopovers() {
    this.popovers.forEach(p => p.hide());
  }

  getAtDueText() {
    const code = this.selected.code;
    const issueDate = new Date(this.selected.issueDate).toISOString()?.replace(/T.*/, '')?.replace(/\-/g, '');
    const customerRef = this.selected.customerDocumentNumber;
    const net = this.data.totalNet + ' ' + this.selected.currency;
    const dueDate = new Date(this.selected.dueDate).toISOString()?.replace(/T.*/, '')?.replace(/\-/g, '');
    return `${code} - Issue date ${issueDate} - Cust reference ${customerRef} - Total net ${net}\nDue date ${dueDate} has not been settled yet. Please settle the invoice and provide payment details. Thank you.`
  }

  setVisibleFields() {
    // if (!this.selected.visibleFields) {
    // DON'T REMOVE, could be used in a future version
    // this.selected.visibleFields = this.visibleSections
    //   .filter(f => f.value['docs'].includes(CompilationTypeData.get(+this.selected.type).code))
    //   .map(m => m.key);

    this.selected.visibleFields = [];

    if (this.selected.type === CompilationTypeData.get('PL').id) {
      this.selected.visibleFields = ['deliveryConditions', 'relatedDocuments', /*'changelogLite'/*, 'coverSheet'*/ 'weightSection' ];
    } else if (this.selected.type === CompilationTypeData.get('DN').id) {
      this.selected.visibleFields = ['deliveryConditions', 'packingConditions', 'relatedDocuments', /*'changelogLite'*/, 'barcodes', 'qrcode', 'weightSection', 'transportation' ];
      this.selected.barcodes = ['dcn', 'dcd', 'cdn'];
      this.selected.lineItems.forEach((_li, idx) => this.selected.barcodes.push(`lac-${idx}`, `liq-${idx}`));
    } else if (this.selected.type === CompilationTypeData.get('IN').id) {
      this.selected.visibleFields = ['taxHint', 'deliveryConditions', 'termsOfPayment',
        'relatedDocuments', /*'changelogLite', 'packingConditions'*/, 'invoiceSendTo', 'invoiceRemark', 'weightSection'];
    } else if (this.selected.issuer === IssuerData.get('NRKA').id && this.selected.type === CompilationTypeData.get('PFIN').id) {
      this.selected.visibleFields = ['taxHint', 'deliveryConditions', 'termsOfPayment',
        'relatedDocuments', /*'changelogLite'*/, 'packingConditions', 'invoiceSendTo', 'weightSection'];
    } else if (this.selected.type === CompilationTypeData.get('CN').id) {
      this.selected.visibleFields = ['relatedDocuments', /*'changelogLite'*/];
    } else {
      this.selected.visibleFields = ['taxHint', 'deliveryConditions', 'termsOfPayment', /*'changelogLite'*/ ];
    }

    if (['SPO', 'PFSPO', 'OBIC'].includes(CompilationTypeData.get(this.selected.type).code)) {
      this.selected.visibleFields.push('obicSummary');
      this.selected.visibleFields.push('ocSummary');
    }
    this.selected.visibleFields.push('issuerFooter');
    // const displayDateSections = DocConfig.getArray().filter(f => f.value.type === 'displayDate');
    // for (const section of displayDateSections) {
    //   if (section.value.checkedDocs && section.value.checkedDocs.includes(CompilationTypeData.get(this.selected.type).code)) {
    //     this.selected.visibleFields.push(section.key);
    //   }
    // }

    // default display dates
    if (['SPO', 'PFSPO', 'CS'].includes(CompilationTypeData.get(this.selected.type).code)) {
      this.selected.visibleFields.push('exwDate', 'dateOfVieArrival');
    }
    if (['SPO', 'PFSPO'].includes(CompilationTypeData.get(this.selected.type).code)) {
      this.selected.visibleFields.push('dateOfPickup');
    }
    // if (['OR'].includes(CompilationTypeData.get(this.selected.type).code)) {
    //   this.selected.visibleFields.push('sendToSection');
    // }
    if (['OC'].includes(CompilationTypeData.get(this.selected.type).code)) {
      this.selected.visibleFields.push('dateOfDelivery');
      this.selected.visibleFields.push('packingConditions');
    }
    if (['PL', 'DN'].includes(CompilationTypeData.get(this.selected.type).code)) {
      this.selected.visibleFields.push('dateOfDispatch');

      const recipient = this.data.businesses.find(f => mongoId(f) === mongoId(this.selected.deliveryRecipient));
      // console.log('dnBoxTable', recipient?.dnBoxTable, this.selected.deliveryRecipient, this.selected.visibleFields, this.selected);
      if (
        recipient?.dnBoxTable 
        && this.selected.type === CompilationTypeData.get('DN').id
        && !this.selected.visibleFields.includes('dnBoxes')
      ) {
        this.selected.visibleFields.push('dnBoxes');
        // console.log('dnBoxes pushed');
      }
      console.log('dnBoxTable2', recipient?.dnBoxTable, this.selected.visibleFields);

    }

    // if (['IN', 'PFIN'].includes(CompilationTypeData.get(this.selected.type).code)) {
    //   for (const item of this.selected.lineItems) {
    //     // if (!item.tcChecked) this.lineItems.toggleShowLineItemTCinPdf(item);
    //     item.tcChecked = true;
    //   }
    // }

    if (!this.selected.visibleFields.includes('fiscalYear') && ['IN'].includes(CompilationTypeData.get(this.selected.type).code)) {
      this.selected.visibleFields.push('fiscalYear');
    }

    if (this.selected.invoiceType === 'service') {
      this.selected.visibleFields = this.selected.visibleFields.filter(f => f !== 'deliveryConditions');
    }

    console.log('visible Fields', this.selected.visibleFields);

  }

  toggleField(field: string) {
    if (!this.selected.visibleFields.includes(field)) {
      this.selected.visibleFields.push(field);
    } else {
      this.selected.visibleFields = this.selected.visibleFields.filter(f => f !== field);
    }
  }

  getTitleString(compilation: CompilationModel) {
    const doctype = CompilationTypeData.get(compilation.type);

    let suffix = '';

    if ((CompilationTypeData.get(compilation.type)?.code === 'IN'
      || CompilationTypeData.get(compilation.type)?.code === 'PFIN')
      && +compilation.invoicePayment) {

      suffix = '  (' + InvoicePaymentData.get(compilation.invoicePayment).name  + ')';
    }

    return [CompilationTypeData.getHeading(compilation), getDocumentNumber(compilation) + suffix];
  }

  setBusinessFields(business: string = null, doc: CompilationModel = null,
    type: string = null, contact: ContactModel = null) {

    if (!doc) doc = this.selected;

    if (!contact) {

      if (!business) business = mongoId(this.selected.recipient);

      const contacts = business && this.data?.businesses?.find(b => b._id === mongoId(business));
      contact = contacts?.contacts?.find(c => c.type == EContactType.Delivery);

      if (!contact || type !== 'deliveryConditions' || !this.selected.deliveryRecipient) {
        contact = contacts?.contacts?.find(c => c.type == EContactType.General);
      }
    }

    // TODO: integrate with shared data getDeliveryAndTerms()

    const vat = contact?.fields?.find(f => +f.type === EContactFieldType.VAT_Number);
    const incoterms = contact?.fields?.find(f => +f.type === EContactFieldType.Incoterms);
    const place = contact?.fields?.find(f => +f.type === EContactFieldType.IncotermsPlace);
    const country = contact?.fields?.find(f => +f.type === EContactFieldType.IncotermsCountry);
    const paymentText = contact?.fields?.find(f => +f.type === EContactFieldType.PaymentText);
    const terms = contact?.fields?.find(f => +f.type === EContactFieldType.PaymentConditions);
    const recipientHours = contact?.fields.find(f => +f.type === +EContactFieldType.ReceptionHours);

    if (!doc.paymentPlan) doc.paymentPlan = new PaymentPlan();
    if (type === null) doc.paymentPlan.recipientUID = vat && vat.value;
    if (type === null) doc.receptionHours = recipientHours && recipientHours.value;
    if (type === null || type === 'termsOfPayment') doc.paymentPlan.text = paymentText && paymentText.value;
    if (type === null || type === 'termsOfPayment') doc.paymentPlan.termsOfPayment = terms && terms.value;
    if (doc.deliveryConditions) {
      if (type === null || type === 'deliveryConditions') doc.deliveryConditions.incoterms = incoterms && incoterms.value;
      if (type === null || type === 'deliveryConditions') doc.deliveryConditions.place = place && place.value;
      if (type === null || type === 'deliveryConditions') doc.deliveryConditions.country = country && country.value;
    }

  }

  customerNameChange(business) {
    const contacts = business && this.data.businesses.find(b => b._id === mongoId(business)).contacts;
    const contact = contacts && (contacts.find(c => c.type === EContactType.General));
    this.selected.customerName = contact.title;
  }

  getType(type: string) {
    return CompilationTypeData.get(type).id;
  }

  reportDatesChanged() {
    this.lineItems && this.lineItems.calcPartialDelivery();
  }

  /// ////////////////////////////////////////  filter ////////////////////////////////////////////////////////////

  onClearFilter(/* event */) {
    this.filter.clear();
    this.filteredCodes = [];
  }

  onDocType(type: number) {
    this.displayedItems = this.data.latestVersionItems.filter(f => f.type == type);
  }

  onDocumentNumber(code: string) {
    this.setCurrentDocumentByCode(code);
  }

  onShowDocumentPreview(visible: boolean = true) {
    // console.log('onShowDocumentPreview', visible, this.showDocumentPreviewHidden);
    this.showDocumentPreview = visible;
    this.cdRef.detectChanges();
  }

  async toggleSidebar(item: CompilationModel) {
    await this.setCurrentDocumentById(mongoId(item));
    this.issuer = this.selected.issuer;
    super.toggleSidebar(this.selected);
  }

  getSelected(selection: string, options: {id: string, name: string}[]) {
    const sel = selection && options ? options.find(s => s.id.toString() === selection.toString()) : null;
    return sel ? sel.name : '';
  }

  getNewDownstreamDoctype() {
    if (!this.selected) return;
    const c = CompilationTypeData;
    if (c.get('OF').id == this.selected.type) return [c.get('FCOR'), c.get('OR'), c.get('SPO'), c.get('PFSPO')];
    if (c.get('FCOR').id == this.selected.type) return [c.get('OR'), c.get('PFSPO'), c.get('SPO')];
    if (c.get('OR').id == this.selected.type)
      return [c.get('OC'), c.get('SPO'), c.get('SPC'), c.get('PFSPO'), c.get('PFSPC')];
    if (c.get('OC').id == this.selected.type) {
      const ret = [c.get('PL'), c.get('DN'), c.get('IN'), c.get('PFIN'), c.get('SPO'), c.get('SPC'), c.get('PFSPO')];
      if (this.issuer !== IssuerData.get('nrkg').id) {
        ret.push(c.get('OC-NRKG'));
      }
      return ret;
    }
    if (c.get('PL').id == this.selected.type) return [c.get('DN'), c.get('SPO'), c.get('SPC')];
    if (c.get('DN').id == this.selected.type) return [c.get('IN'), c.get('PFIN'), c.get('SPO'), c.get('SPC')];
    if (c.get('IN').id == this.selected.type) return [c.get('CN'), c.get('SPO'), c.get('SPC')];
    if (c.get('PFIN').id == this.selected.type) return [c.get('PFCN')];
    if (c.get('OBIC').id == this.selected.type) return [c.get('PFSPO'), c.get('SPO')];
    if (c.get('PFSPO').id == this.selected.type) return [c.get('SPO')];
    if (c.get('PFSPC').id == this.selected.type)
      return this.issuer === IssuerData.get('nrkg').id ? [c.get('SPC'), c.get('OR-NRKA')] : [c.get('SPC')];
    if (c.get('CS').id === this.selected.type) return [c.get('SPO')];
    return [];
  }

  /// //////////////////////////////////  document  ////////////////////////////////////////////////////

  async setField(field: string, data: any, code = this.selected.code) {
    // console.log('set field', field, data);
    if ((code && code !== this.selected.code) || this.selected._id) {
      const doc = await this.api.loadCompilationByCode(code);
      doc[field] = this.selected[field] = data;

      // TODO: Object.assign in api service
      const changes = Changelog.changeMap(this.copy, doc, field);
      await Changelog.addAutolog(doc, this.auth.user, this.api, changes);

      // console.log('====> set Field ', code, field, data);
      this.api.saveCompilation(doc);
    }
  }

  // setFieldInRelevantDocs(field: string, data: any) {
  //   const docs = DocConfig.get(field).docs;
  //   docs.forEach(doc => {
  //     const id = CompilationTypeData.get(doc);
  //     this.tree.findDocByUpstreamType
  //     this.setField(field, data, code)
  //   });
  // }

  // async changeInTree(field: any, data: any) {
  //   if (field === 'sampleRequest') {
  //     let isConfirmed = confirm("Are you sure to change sample request setting");
  //     if (isConfirmed) {
  //       for (const doc of this.tree.getFlat()) {
  //         this.setField(field, data, doc.code);
  //       }
  //     } else {
  //       event?.preventDefault();
  //     }
  //   } else {
  //     for (const doc of this.tree.getFlat()) {
  //       this.setField(field, data, doc.code);
  //     }
  //   }
  // }

  async changeInTree(event: any) {
    let isConfirmed = confirm("Are you sure to change sample request setting");
    if (isConfirmed) {
      this.selected.sampleRequest = !this.selected.sampleRequest;
        for (const doc of this.tree.getFlat()) {
          this.setField('sampleRequest', this.selected.sampleRequest, doc.code);
        }
    } else {
      event.preventDefault();
    }
  }

  async onOfferDataChanged(key: string, value: any) {
    if (this.selected._id) {
      const doc = await this.api.loadCompilation(this.selected._id);

      if (!doc.offerData) doc.offerData = new OfferData();

      if (key === 'offerStatus') {
        if (+this.selected.offerData.offerStatus !== 6 || +doc.offerData.offerStatus !== 2) {
          this.selected.offerData.statusComment = doc.offerData.statusComment = 1;
        }
        this.statusCommentOptions = OfferStatusData.getOptions(+value);
      }

      if (key !== 'updatedAt') doc.offerData[key] = value;

      this.selected.offerData.updatedAt = doc.offerData.updatedAt = new Date();

      this.api.saveCompilation(doc);
    }
  }

  reloadContacts() {
    // this.subscriptions.push(this.api.loadBusiness(mongoId(this.selected.recipient)).subscribe(business => {
      const business = this.data.businesses.find(f => mongoId(f) === mongoId(this.selected.recipient));
      this.contacts = business?.contacts || [];
      this.recipientContactOptions = [{ id: null, name: '' }, ...this.contacts
        .filter(f => f.type === EContactType.Employee)
        .map(m => ({ id: m._id, name: m.title }))];
    // }));
  }

  onRecipient(contact) {
    // console.log('on recipient', contact);

    this.cdRef.detach();

    this.dialogService.open(CommonDialogComponent, {
      autoFocus: true,
      closeOnBackdropClick: false,
      hasBackdrop: true,
      context: {
        dialogType: NrkDialogType.updateDeliveryAndTerms,
        compilation: this.selected,
      },
    }).onClose.subscribe(async x => {
      if (x && x.button === NrkDialogButton.update) {
        if (x.updateDelivery && this.selected.deliveryConditions) {
          this.selected.deliveryConditions.incoterms = x.deliveryAndTerms?.incoterms?.value;
          this.selected.deliveryConditions.place = x.deliveryAndTerms?.place?.value;
          this.selected.deliveryConditions.country = x.deliveryAndTerms?.country?.value;
        }
        if (x.updateTermsOfPayment && this.selected.paymentPlan) {
          this.selected.paymentPlan.termsOfPayment = x.deliveryAndTerms?.terms?.value;
          this.selected.paymentPlan.text = x.deliveryAndTerms?.paymentText?.value;
          if (['IN', 'PFIN'].includes(CompilationTypeData.get(+this.selected.type).code)) this.selected.dueDate = this.selected.nextPaymentDate = this.calcDueDate();
        }
      }
      this.cdRef.reattach()
    })

    this.reloadContacts();

    if (contact.business) {
      this.selected.paymentPlan.recipientUID = this.contactUtil.getContactInfoFromBusiness(contact.business, DocConfig.get('recipientUID').fields);
      this.selected.receptionHours = this.contactUtil.getGeneralContact(mongoId(contact.business))?.fields?.find(f => +f.type === +EContactFieldType.ReceptionHours)?.value || '';
    }

    this.selected.accountManager = (this.data.getBusinessManagerUser(this.selected.recipient)?.name) || '';
  }

  onRecipientContactChanged(contact: string) {
    const _contact = this.contacts.find(f => f._id === mongoId(contact) && +f.type === EContactType.Employee);
    this.selected.recipientContact
      = this.contactUtil.getContactInfo(_contact, DocConfig.get('recipientContact').fields);
  }

  // TODO: remove access legacy
  getIssuerBusinessId(event: number) {
    const issuer = this.issuerOptions.find(f => mongoId(f.id) === mongoId(event));
    if (issuer) {
      const business = this.data.businessOptions.find(f =>
        f.name === issuer.name ||
        (f.name === 'NRI' && issuer.id === 1) ||
        (f.name === 'NRT' && issuer.id === 6) ||
        (f.name === 'AMS DE Vlotho' && issuer.id === 9) ||
        (f.name === 'Fornax DK Slkeborg' && issuer.id === 10)
      );
      // console.log('getissuerBusinessId', business, this.data.businessOptions, issuer, this.issuerOptions);
      return business.id;
    }
    return null;
  }

  onIssuerChanged(event) {
    this.issuer = +event;
    const b = this.getIssuerBusinessId(event);
    if (b && !this.selected.nrkjOverride) this.selected.issuerAddress = this.contactUtil.getAddressFromBusiness(b, DocConfig.get('issuerAddress').fields);

    // const issuer = this.data.businesses.find(f => f._id === mongoId(b))?.contacts.find(f => f.type === EContactType.General);
    // if (!this.selected.documentFooter) this.selected.documentFooter = new DocumentFooter();
    // this.selected.documentFooter.address = this.getAddress(issuer);
    // this.selected.documentFooter.registry = this.getRegistry(issuer);
    // this.selected.documentFooter.bank = this.getBank(issuer);
  }

  onIssuerContactChanged(user) {
    let contact = this.data.users.find(f => mongoId(f) == mongoId(user))?.contact;
    if (contact) {
      this.selected.issuerContact
      = this.contactUtil.getContactInfo(contact, DocConfig.get('issuerContact').fields);
    }
  }

  onInvoiceType(type: string, update = true) {
    if (update) this.selected.invoiceType = type;
    if (type === 'service') {
      this.dialogService.open(CommonDialogComponent, {
        context: {
          dialogType: NrkDialogType.okCancel,
          message: 'Do you want to delete delivery conditions?',
          okText: 'Yes',
          cancelText: 'No',
        },
      }).onClose.subscribe(async x => {
        if (x.button === NrkDialogButton.save) {
          this.selected.deliveryConditions.incoterms = null;
          this.selected.deliveryConditions.place = null;
          this.selected.deliveryConditions.country = null;
          this.selected.visibleFields = this.selected.visibleFields.filter(f => f !== 'deliveryConditions');
        }
      });
    }
  }

  // onMeansOfTransportChanged(transport: string) {
  //   this.selected.meansOfTransport = transport;
  //   this.data.setCSIdentifier(this.selected);
  // }
  // async addMeansOfTransport() {
  //   await this.api.saveCompilationData('meansOfTransportStore', this.selected.meansOfTransport, true);
  //   await this.data.reloadCompilationData();
  //   this.meansOfTransportOptions = this.data.compilationData.meansOfTransportStore.map(m => ({id: m, name: m}));
  // }
  // async removeMeansOfTransport() {
  //   await this.api.saveCompilationData('meansOfTransportStore', this.selected.meansOfTransport, false);
  //   await this.data.reloadCompilationData();
  //   this.meansOfTransportOptions = this.data.compilationData.meansOfTransportStore.map(m => ({id: m, name: m}));
  // }

  onDeliveryChange(contact: ContactModel) {

    // if (this.selected.type === CompilationTypeData.get('SPO').id && mongoId(this.selected.deliveryRecipient) === mongoId(this.data.business.jerich) &&  mongoId(this.selected.recipient) === mongoId(this.data.business.nrkv)) {
    //   this.selected.deliveryConditions = new DeliveryConditions();
    //   this.selected.deliveryConditions.incoterms = 'DAP';
    //   this.selected.deliveryConditions.country = 'Austria';
    //   this.selected.deliveryConditions.place = '8200 Hofstätten an der Raab';
    // } else {
    //   this.changeDeliveryConditions(contact);
    // }

    if (this.selected.type === CompilationTypeData.get('SPO').id && mongoId(this.selected.recipient) === mongoId(this.data.business.nrkv)) {
      this.selected.deliveryConditions = new DeliveryConditions();
      this.selected.deliveryConditions.incoterms = 'EXW';
      this.selected.deliveryConditions.country = 'Vietnam';
      this.selected.deliveryConditions.place = 'Ho Chi Minh City';
    } else {
      this.changeDeliveryConditions(contact);
    }


  }

  changeDeliveryConditions(contact: ContactModel) {
    this.cdRef.detach();
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.updateDelivery,
        contact: contact,
        compilation: this.selected,
        message: 'Do you want to update delivery conditions?',
        okText: 'Yes',
        cancelText: 'No',
      },
    }).onClose.subscribe(async x => {
      if (x && x.button === NrkDialogButton.save) {
        // this.setBusinessFields(null, null, 'deliveryConditions', contact);
        const data = this.data.getDeliveryAndTerms(null, contact);
        this.selected.deliveryConditions.incoterms = data.incoterms?.value;
        this.selected.deliveryConditions.place = data.place?.value;
        this.selected.deliveryConditions.country = data.country?.value;
      }
      this.cdRef.reattach();
    });
  }

  pfsposChangelogOChelper = [];
  onLineItemsChanged(data: any = null) {
    if (!this.selected.lineItems || !this.selected.lineItems.length) return;

    if (data && data.pfspo && data.pfspo.assigned) {
      Changelog.addAutolog(this.selected, this.auth.user, this.api, [
        { quickText: 'Assign PFSPO', text: `Add: Pos ${data.pfspo.idx}: ${data.pfspo.docNum}` },
      ]);
      this.pfsposChangelogOChelper.push(data.pfspo);
    } else if (data && data.pfspo && data.pfspo.removed) {
      Changelog.addAutolog(this.selected, this.auth.user, this.api, [
        { quickText: 'Assign PFSPO', text: `Remove: Pos ${data.pfspo.idx}: ${data.pfspo.docNum}` },
      ]);
      this.pfsposChangelogOChelper.push(data.pfspo);
    }

    let netWeight = 0;
    for (const el of this.selected.lineItems) {
      let fp = el.finishedProduct;
      if (!fp) continue;
      if (!fp._id) fp = this.data.finishedProducts.find(f => mongoId(f) === mongoId(fp)); // await this.api.loadFinishedProductById(mongoId(fp));

      if (fp?.machineryWeight) {
        netWeight += fp.machineryWeight;
      } else {
        if (fp && fp.content && fp.content.energy
          && fp.content.energy.width && fp.content.energy.rollLength
          && fp.product && fp.product.weight) {

          netWeight += (fp.content.energy.width / 1000)
            * fp.content.energy.rollLength
            * (fp.product.weight / 1000)
            * el.quantity
        }
      }
    }
    this.selected.netWeight = ''+netWeight;
    // console.log('...onlineitems end', this.selected.lineItems.map(m => m.finishedProduct?.code))
  }

  onOptionalLineItemsChanged() {
    this.lineItems?.recalc();
  }

  getLabel(section: string) {
    // TODO: generalize transactionReceipt as generalupload field
    if (section === 'transactionReceipt' && +this.selected.type === CompilationTypeData.get('CS').id) return 'Upload';
    return DocConfig.getSections()[section].label;
  }

  async updateInvoiceUpload(section: string, updateCompleted: boolean, saveDn = true) {
    if (updateCompleted) this.selected[section].completed = true;
    const qtxt = DocConfig.get(section).label;
    const txt = 'completed and upload successful';
    await Changelog.addAutolog(this.selected, this.auth.user, this.api, [
      { quickText: qtxt, text: txt },
    ]);
    if (updateCompleted && section === 'transactionReceipt') {
      await new Promise((res, rej) => {
        this.dialogService.open(CommonDialogComponent, {
          context: {
            dialogType: NrkDialogType.paymentDate,
            compilation: this.selected,
            okText: 'Ok',
          },
        }).onClose.subscribe(async x => {
          res(true);
        });
      })
    }
    this.api.saveCompilation(this.selected).then(async d => {
      // this.selected = d;
      if (saveDn) {
        const deliverynote = this.tree.findDocByUpstreamType(this.selected, 'DN');
        const doc = await this.api.loadCompilationByCode(deliverynote.code);
        doc[section] = this.selected[section];
        this.api.saveCompilation(doc);
      }
    });
  }

  async updatePaymentDate() {
    const doc = await this.api.loadCompilation(mongoId(this.selected));
    if (doc) {
      doc.paymentDate = this.selected.paymentDate;
    }
    this.api.saveCompilation(doc);
  }

  removeParent(item: CompilationModel) {
    item.parent = null;
    this.api.updateField(item.code, 'parent', null);
  }

  getMailSubject(copyToClipboard = true) {
    console.log('getMailSubject', this.selected.recipient, this.data.businesses);
    const date = moment(new Date).format('YYMMDD');
    const recipient = this.data.businesses.find(f => mongoId(f) === mongoId(this.selected.recipient))?.name ?? '';
    const docnum = getDocumentNumber(this.selected, null, false);
    const cref = this.selected?.customerReference ? this.data.businesses.find(f => mongoId(f) === mongoId(this.selected.customerReference))?.name : '';
    const cdoc = this.selected?.customerDocumentNumber ? ` - ${this.selected?.customerDocumentNumber}` : '';
    let subject = ['OBIC'].includes(CompilationTypeData.get(this.selected.type).code) 
      ? `${date}_${recipient}_${cref}_${docnum}${cdoc}` 
      : `${date}_${recipient}_${docnum}${cdoc}`;
    if (this.selected?.dueDate) subject += ` Due ${moment(this.selected.dueDate).format('YYMMDD')}`;

    // if (!recipient || !this.data.businesses) {
    //   this.api.debugConsoleLog(`recipient: ${this.selected?.recipient} businesses: ${this.data.businesses?.length}`);
    // } 
    if (copyToClipboard) this.copyToClipboard(subject);
    return subject;
  }

  getInMailSubject(copyToClipboard = true) {
    if (this.selected.type !== CompilationTypeData.get('IN').id) return '';
    const date = moment(new Date).format('YYMMDD');
    const issueDate = moment(this.selected.issueDate).format('YYMMDD');
    const dueDate = moment(this.selected.dueDate).format('YYMMDD');
    // const recipient = this.data.businesses.find(f => mongoId(f) === this.selected.recipient)?.name;
    const docnum = getDocumentNumber(this.selected, null, false);
    const cref = this.selected?.customerDocumentNumber ||  'none';
    const net = this.data.totalNet + ' ' + this.selected.currency;
    const subject =`${docnum} - Issue date ${issueDate ?? 'n/a'} - Cust reference ${cref ?? 'n/a'} - Date ${date ?? 'n/a'} - Total net ${net ?? 'n/a'}\nDue date ${dueDate ?? 'n/a'}`;
    if (copyToClipboard) this.copyToClipboard(subject);
    return subject;
  }

  getClipboardList() {
    return [this.getMailSubject(false), this.getInMailSubject(false)];
  }

  /// /////////////////////////////// combined shipment //////////////////////////////////////////

  async addToCombinedShipment(cs: CompilationModel) {

    const doc = await this.api.loadCompilation(mongoId(cs));
    // let shipmentLineItemExists = false;

    const alreadyInCSDoc = await this.api.findCombinedShipment(this.selected.code);
    // console.log('already in cs doc', alreadyInCSDoc);
    if (alreadyInCSDoc) {
      this.toastrService.danger(`Item ${this.selected.nameOverride || this.selected.code} already added to ${alreadyInCSDoc.nameOverride || alreadyInCSDoc.code}`, 'Validation Error');
      return;      
    }
    doc.shipmentLineItems?.forEach(li => {
      if (this.selected.code === li.code) {
        const name = li.document.nameOverride ? li.document.nameOverride : li.document.code;
        this.toastrService.danger(`Item ${name} already added`, 'Validation Error');
        // shipmentLineItemExists = true;
        return;
      }
    });

    // if (!this.selected._id) this.selected = await this.saveItem(this.selected, this.selected.draft, true); // if it is a new, unsaved (PF)SPO/Doc save it
    const sli = new ShipmentLineItem();
    sli.code = this.selected.code;
    if (!doc.shipmentLineItems.map(m => m.code).includes(sli.code)) doc.shipmentLineItems.push(sli);
    await Changelog.addAutolog(doc, this.auth.user, this.api, [{
      quickText: 'Change Shipment Line Items',
      text: `Added: ${getDocumentNumber(this.selected)} (in PFSPO by ${this.auth.user.short})`,
    }]);
    // console.log('add to combined shipment pre save item', doc);
    this.api.saveCompilation(doc);

    // console.log('add to combined shipment exw date', this.selected.exwJapanDate);
    this.selected.transportRun.relatedCS = doc && getDocumentNumber(doc);
    this.tree.linkedCS = JSON.parse(safeStringify(doc));
    this.selected.pfspoWithShipment = true;
    this.selected.exwJapanDate = doc.exwJapanDate;
    this.selected.arrivingVieDate = doc.arrivingVieDate;
    this.selected.meansOfTransport = doc.meansOfTransport;
    await Changelog.addAutolog(this.selected, this.auth.user, this.api, [{
      quickText: 'Change Combined Shipment',
      text: 'Add to ' + getDocumentNumber(doc),
    }]);

    await this.saveItem(this.selected, this.selected.draft, true);
  }

  // async getCombinedShipment(item: CompilationModel = null) {
  //   if (+this.selected.type !== CompilationTypeData.get('PFSPO').id
  //   && +this.selected.type !== CompilationTypeData.get('SPO').id) {
  //     return null;
  //   }

  //   if (!item) item = this.selected;

  //   console.warn('!!!!!!!!!!!!!! check relatedCs tree', item);
  //   console.log(await this.api.findCombinedShipment(item.code), this.tree.linkedCS);
  //   return await this.api.findCombinedShipment(item.code);
  // }

  async removeFromCombinedShipment(item: CompilationModel = null) {
    if (!item) item = this.selected;
    if (!this.tree.linkedCS) return;

    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.okCancel,
        message: `Are you sure to remove ${item.code} from ${this.tree.linkedCS.code}`,
        okText: 'Yes',
        cancelText: 'Cancel',
      },
    }).onClose.subscribe(async x => {
      if (x && x.button === NrkDialogButton.save) {
        const cs = await this.api.removeFromCombinedShipment(item, this.tree.linkedCS);
        if (!cs.shipmentLineItems.find(f => f.code === this.tree.linkedCS?.code)) {
          this.tree.linkedCS = this.selected.transportRun.relatedCS = null;
          this.selected.pfspoWithShipment = false;
          item.exwJapanDate = null;
          item.arrivingVieDate = null;
          item.transportRun.transportStatus = TransportStatusData.get('planned').id;
          Changelog.addAutolog(this.selected, this.auth.user, this.api, [{
            quickText: 'Change Combined Shipment',
            text: 'Removed from ' + getDocumentNumber(cs),
          }]);
          await Changelog.addAndSaveAutolog(cs, this.auth.user, this.api, [{
            quickText: 'Change Shipment Line Items',
            text: `Removed: ${getDocumentNumber(this.selected)} (in PFSPO by ${this.auth.user.short})`,
          }]);
        }
      }
    });
  }

  async createNewCsFromCurrentDocument() {
    const backup = safeStringify(this.selected);
    const prevDocBackup = safeStringify(this.prevDoc);
    await this.doCreateDocument(CompilationTypeData.get('CS').id, 'empty', false);
    this.prevDoc = JSON.parse(backup);
    const cs = await this.saveItem(this.selected, true);
    this.tree.linkedCS = cs;
    this.selected = this.prevDoc;
    // this.clipboardList = [await this.getMailSubject(false), this.getInMailSubject(false)];
    this.prevDoc = prevDocBackup && JSON.parse(prevDocBackup);
    this.addToCombinedShipment(cs);
  }

  async setTransportStatus(item: any, transportStatus: number) {
    this.popovers.forEach(p => p.hide());

    if (item.transportRun.transportStatus === transportStatus) return;

    const doc = await this.api.loadCompilationByCode(item.code);

    await Changelog.addAndSaveAutolog(doc, this.auth.user, this.api, [{
      quickText: 'Change Transport status',
      text: `From ${TransportStatusData.get(doc.transportRun.transportStatus).name} to ${TransportStatusData.get(transportStatus).name} (in document overview)`,
    }]);

    doc.transportRun.transportStatus = item.transportRun.transportStatus = transportStatus;
    this.api.saveCompilation(doc);
    
  }

  async generateOrderReport() {
    const or = this.getDocumentTree('OR');
    if (!or || !or.length || !/^OR/.test(or[0].code)) {
      this.toastrService.danger('No related Order found for this document', 'Order not found');
      return;
    }
    const orders = {
      orientation: 'portrait',
      filterInternal: true,
      order: or[0].code, // this.selected.code, // order number (code)
      orderNumberVersioned: this.selected.nameOverride || getDocumentNumber(this.selected),
      relatedOcs: 2, // 1 = none, 2 = all, 3 = non invoiced
      relatedInvoices: 2, // 1 = none, 2 = all, 11 = not paid, 12 = partially paid, 12 = fully paid
      relatedCreditNotes: 2, // 1 = none, 2 = all
    }
    this.reportsSearch = { orders: orders };
    this.cdRef.detectChanges();
    this.reportsPrinterRef.loading = true;
    this.reportsPrinterRef.pdfSidebar = true;
    await this.reportsPrinterRef.reloadData();
    await this.reportsPrinterRef.downloadPdf();
    this.reportsSearch = null;
  }

  // getOrderNet() {
  //   const or = this.tree?.linkedOR;
  //   const orData = this.data?.calcData(or);
  //   return orData.totalNet + ' ' + or.currency;
  // }

  getPfspoReportParams() {
    return {
      id: 'OSPO',
      report: 'openspo',
      params: JSON.stringify({
        combinedShipment: this.selected.code, // TODO: remove legacy (mask detto)
        combinedShipments: [this.selected.code],
        sortType: 3,
        dateType: DateSelectionData.all.id,
        dateFrom: null,
        dateTo: null,
      }),
    }
  }

  getNonInvoicedOCParams() {
    return {
      id: 'NIOC',
      report: 'noninvoiced',
      params: JSON.stringify({
        combinedShipments: [this.selected.code],
        sortType: 1,
        dateType: DateSelectionData.all.id,
        dateFrom: null,
        dateTo: null,
      }),
    }
  }

  /// //////////////////////////////////  storage  ////////////////////////////////////////////////////

  // TODO: calc in backend
  public async getCalculatedCode(compilation: CompilationModel, draft = false): Promise<string> {
    if (compilation.version > 1) return compilation.code;
    let currentIssuer = compilation.issuer || this.selected.issuer;
    if (compilation.nrkjOverride && ['IN', 'CN', 'PFIN', 'PFCN'].includes(CompilationTypeData.get(+compilation.type).code)) {
      currentIssuer = IssuerData.get('nrkj').id
    }
    const docnums = this.data.latestVersionItems
      .filter(f=> compilation.nrkjOverride ? /^INNRKJ\d\d/.test(f.code) : f.issuer == currentIssuer && f.type == this.selected.type)
      .map(m => m.code);
    // console.log('=====================> docnums', docnums);
    const doctypeCode = CompilationTypeData.get(+compilation.type).code;
    const issuerCode = IssuerData.get(currentIssuer).name;
    const yearCode = new Date().getFullYear().toString().substr(-2);
    const finalnums = docnums.filter(f =>
      f.match(new RegExp(doctypeCode + issuerCode + (draft ? '-DRAFT-' : '') + yearCode + '\\d\\d\\d\\d'))
    );
    let num = finalnums.length > 0 ?
      finalnums.map(m => parseInt(m.substr(-4), 10)).sort((a, b) => a < b ? 1 : -1)[0] + 1 : 1;
    if (draft) {
      const data = new CompilationDataModel();
      data.draftNumbers = await this.api.getCompilationData('draftNumbers');
      let count = data.draftNumbers.length && (data.getDraftNumber(+compilation.type) + 1) || 0;
      if (new Date().getFullYear() === data.getYear(+compilation.type) + 1) {
        data.setYear(+compilation.type);
        count = 1;
      }
      num = Math.max(num, count);
      if (data.draftNumbers.length) {
        data.setDraftNumber(+compilation.type, num);
      } else {
        data.draftNumbers = [{ type: +compilation.type, year: new Date().getFullYear(), count: num}];
      }
      this.api.saveCompilationData('draftNumbers', data.draftNumbers);
    } else {
      if (/DRAFT/.test(this.selected.code)) {
        // console.log('===> was draft', this.selected.code);
        this.selected.draftCode = this.selected.code;
      }
    }

    const numberCode = `0000${num}`.slice(-4);
    const docNum =  doctypeCode + issuerCode + (draft ? '-DRAFT-' : '') + yearCode + numberCode;
    // if (compilation.nrkjOverride) compilation.nameOverride =  compilation.code.replace(/NRK./, 'NRKJ');
    
    return docNum;
  }

  switchToVersion(item: CompilationModel) {
    this.setCurrentDocumentByCode(item.code, item.version);
  }

  async createNewVersion() {
    await this.doCreateDocument(this.selected.type, 'all', false, true);
  }

  loadItems(): Promise<void> {
    return null;
  }

  scrollTop() {
    const el = document.getElementsByClassName('sidebar-fix');
    if (el[0]) el[0].scrollTop = 0;
  }

  isOffersPage() {
    return this.auth && this.auth.user && this.auth.user.erpRoles.offers && /\/pages\/erp\/offers/.test(this.router.url)
  }

  async getDocCodesByLot(lot: string) {
    console.log('lot', lot);
    this.filteredCodes = await this.api.getDocCodesByLot(lot);
    this.filter.tcNumber = '';
    this.setDisplayedItems();
  }

  async getDocCodesByTc(tc: string) {
    console.log('tc', tc);
    this.filteredCodes = await this.api.getDocCodesByTc(tc);
    this.filter.lot = '';
    this.setDisplayedItems();
  }

  onChangeNrkjOverride() {
    this.selected.nrkjOverride = this.selected.nrkjOverride ? undefined : true;
    const b = this.getIssuerBusinessId(IssuerData.get(this.selected.nrkjOverride ? 'nrkj' : 'nrka').id);
    if (b) {
      this.selected.issuerAddress = this.contactUtil.getAddressFromBusiness(b, DocConfig.get('issuerAddress').fields);
      if (this.selected.nrkjOverride) this.selected.issuerAddress = this.selected.issuerAddress + '\nCRN: 0107-01-007886';
    }
    this.setRelatedDocuments();
    this.setNrkjOverrideNumber(this.selected);
  }

  setNrkjOverrideNumber(doc: CompilationModel) {
    // if (this.selected.nrkjOverride && !/NRKJ/.test(this.selected.code) && (!this.selected.nameOverride || /NRKJ/.test(this.selected.nameOverride))) {
    //   this.selected.nameOverride = this.selected.code.replace(/NRKA/, 'NRKJ'); //getDocumentNumber(this.selected).replace(/NRKA/, 'NRKJ');
    //   this.selected.nameOverride = this.selected.nameOverride.replace(/NRKA/, 'NRKJ');
    // } else if (!this.selected.nrkjOverride && /NRKJ/.test(this.selected.nameOverride)) {
    //   this.selected.nameOverride = undefined;
    // }
    // console.log('setNrkjOverrideNumber', this.selected.nrkjOverride, this.selected.code, this.selected.nameOverride);
    if (doc.nrkjOverride && !['IN'].includes(CompilationTypeData.get(doc.type).code)) {
      doc.nameOverride = doc.code.replace(/NRK./, 'NRKJ');
    } else if (/NRKJ/.test(doc.nameOverride)) {
      doc.nameOverride = undefined;
    }
  }

  // internalUpdatesSnapshotData = ''
  // internalUpdatesSnapshot() {
  //   this.internalUpdatesSnapshotData = JSON.stringify({
  //     remarks: this.selected.projectRemark,
  //     notInSrReprot: this.selected.notInSrReport,
  //   })
  // }

  // checkForInternalUpdates() {
  //   const data = JSON.stringify({
  //     remarks: this.selected.projectRemark,
  //     notInSrReprot: this.selected.notInSrReport,
  //   })
  //   if (data !== this.internalUpdatesSnapshotData) {
  //     if (confirm('Save changes?')) {
  //       this.data.updateInternalUpdates(this.selected)
  //     } else {
  //       const res = JSON.parse(this.internalUpdatesSnapshotData);
  //       this.selected.projectRemark = res.remarks;
  //       this.selected.notInSrReport = res.notInSrReprot;
  //     }
  //   }
  // }
  // async updateInternalUpdates(ref: CompilationModel, finalize = false) {
  //   this.dialogService.open(CommonDialogComponent, {
  //     context: {
  //       header: 'Remark',
  //       message: 'Enter Summary',
  //       dialogType: NrkDialogType.input,
  //     },
  //   }).onClose.subscribe(async data => {
  //     if (data.response) {
  //       const doc = await this.api.loadCompilationByCode(ref.code);
  //       doc.internalUpdates = ref.internalUpdates;
  //       // doc.profitMarginText = ref.profitMarginText;
  //       doc.projectRemark = ref.projectRemark;
  //       doc.projectCompleted = ref.projectCompleted;
  //       if (finalize) {
  //         doc.notInSrReport = ref.notInSrReport = doc.projectCompleted;
  //       } else {
  //         doc.notInSrReport = ref.notInSrReport;
  //       }
  //       ref.projectRemark.items.push({
  //         date: new Date(),
  //         user: this.auth.user?.short,
  //         text: data.response,
  //       })
  //       doc.projectRemark = ref.projectRemark;
  //       this.api.saveCompilation(doc);
  //     } else {
  //       this.toastrService.danger('No remark entered', 'Remark required')
  //     }
  //   });
  // }

  /// //////////////////////////////////  footer  ////////////////////////////////////////////////////

  getAddress(issuer: ContactModel) {
    // console.log('nrkj override', this.selected.nrkjOverride, issuer);
    if (this.selected.nrkjOverride) {
      return `
Nippon Rika Industries Corporation
20-6 Ohi 1-Chome
Tokyo 140-8503
JAPAN
`
    }
    const name = issuer.title;
    const street = issuer.fields.find(f => +f.type === EContactFieldType.Street);
    const zip = issuer.fields.find(f => +f.type === EContactFieldType.Zip);
    const city = issuer.fields.find(f => +f.type === EContactFieldType.City);
    // const country = issuer.fields.find(f => +f.type === EContactFieldType.Country);
    return `
${name}
${street?.value}
${zip?.value} ${city?.value}
`
  }

  getRegistry(issuer: ContactModel) {
    if (this.selected.nrkjOverride) return '';
    const reg = issuer.fields.find(f => +f.type === EContactFieldType.RegistrationNumber);
    const vat = issuer.fields.find(f => +f.type === EContactFieldType.VAT_Number);
    return `
${reg?.value || ''}
VAT ID: ${this.selected.nrkjOverride ? 'ATU68441858' : vat?.value}
EORI: ATEOS1000061840
Tax ID: 09231/5142
DUNS: 300407839
`
  }

  getBank(issuer: ContactModel) {
    if (this.selected.nrkjOverride) {
      return `
Bank Address: 
SUMITOMO MITSUI BANKING CORP.
Omori Branch, 2-3-4 Sanno, 
Ota-ku, Tokyo 143-0023, JAPAN
A/C No: 785-0047312, SWIFT: SMBCJPJT
`
    }
    const bank = issuer.fields.find(f => +f.type === EContactFieldType.Bank);
    const iban = issuer.fields.find(f => +f.type === EContactFieldType.IBAN);
    const bic = issuer.fields.find(f => +f.type === EContactFieldType.BIC);
    return `
${bank && bank.value}
IBAN: ${iban && iban.value}
BIC: ${bic && bic.value}`
  }

}
